import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { DataGridPro, GridActionsCellItem, koKR } from '@mui/x-data-grid-pro';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Drawer,
  Grid,
  IconButton,
  LinearProgress,
  Tooltip,
  Skeleton,
  Typography,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import {
  Close,
  KeyboardArrowDown,
  TableChart,
} from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';
import SplitterLayout from 'react-splitter-layout';
import 'react-splitter-layout/lib/index.css';
import {
  DialogTitleClose,
  PaperComponent,
} from "../dialog";
import {
  CustomNoRowsOverlay,
  // CustomLoadingOverlay,
} from "../datagrid";
import {
  dateFormat,
  hideWatermark,
  GlassUtils,
} from "../../utils";
import { uploadFilePath, fileServerUrl, filePreviewServerUrl } from '../../config';
import { SecurityUtils } from "../../utils";

import * as gclientActions from "../../store/gclient";
import * as securityActions from "../../store/security";
import * as g04docuFileActions from "../../store/g04docuFile";
import * as securityRequestActions from "../../store/securityRequest";
import * as g04docuMaterialApprovalActions from "../../store/g04docuMaterialApproval";
import * as gsupplyConfirmActions from "../../store/gsupplyConfirm";
import * as gprojectActions from "../../store/gproject";
import * as subMatFolderActions from "../../store/subMatFolder";

import GProjectG04ContentView from './GProjectG04ContentView';
// import PdfViewer from './PdfViewer';
// import FileViewer from 'react-file-viewer';

import { G04docuMaterialApprovalManagement } from '../G04docuMaterialApproval';
import { G04docuGTestManagement } from '../G04docuGTest';
import GSupplyConfirmSummaryDialog from "./GSupplyConfirmSummaryDialog";
import DocumentViewerDrawer from "../common/viewer/DocumentViewerDrawer";

const STORAGE_KEY_PREFIX = {
  MATERIAL_APPROVAL: 'g04_generator_material_approval_selected_',
  SUPPLY_CONFIRM: 'g04_generator_supply_confirm_selected_'
};

const TTL_1WEEK = 7 * 24 * 60 * 60 * 1000; // 일주일

// 문자열에서 HST 텍스트 제거 (언제 적용할지는 호출부에서 결정)
const removeHSTFromCode = (code) => {
  return code.replace(/\s*HST\s*/g, "").trim();
};

const GProjectG04GeneratorDialog = ({
  gsupplyConfirm,
  crudMode,
  setCrudMode,
  open,
  setOpen,
  gcertifications,
  selectedRow,
}) => {
  const [show, setShow] = useState(true);
  const [selected, setSelected] = React.useState([/*'DOMESTIC_AUTH'*/]); // 국내가공유리제품 노드 기본 체크하여 출력되지 않도록 한다. => 기본 체크 풀어 출력되도록 변경
  const [g04docuDataWithoutDocus, setG04docuDataWithoutDocus] = useState([]);
  const [g04docuDataWithDocus, setG04docuDataWithDocus] = useState([]);
  const [documentPath, setDocumentPath] = useState("");
  const [showFileViewer, setShowFileViewer] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const [fileType, setFileType] = useState("");
  const [drawerState, setDrawerState] = useState({});
  const [openSubstitute, setOpenSubstitute] = useState(false);
  const [dataForMaterialApproval, setDataForMaterialApproval] = useState(undefined);
  const [dataForGTestSubstitute, setDataForGTestSubstitute] = useState(undefined);
  const [openRequest, setOpenRequest] = useState(false);
  const [closedGClientList, setClosedGClientList] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [buildingToc, setBuildingToc] = useState(false);
  const [pageSize, setPageSize] = useState(100);
  const [gclientsInMaterialApproval, setGClientsInMaterialApproval] = useState([]);
  const [gsupplyConfirms, setGSupplyConfirms] = useState([]);
  const [gsupplyConfirmSummaryData, setGSupplyConfirmSummaryData] = useState([]);
  const [gsupplyConfirmSummaryFilteredData, setGSupplyConfirmSummaryFilteredData] = useState([]);
  const [openSummary, setOpenSummary] = useState(false);
  const [excludedGClientIds, setExcludedGClientIds] = useState([]);
  const [documentViewerDrawerOpen, setDocumentViewerDrawerOpen] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  
  // 미리 선언해야 사용할 수 있으므로 위치 변경
  // const g04docusSubMaterialProcess = useSelector((state) => state.g04docu.g04docusSubMaterialProcess);

  const handleRequestDialogClose = () => {
    setOpenRequest(false);
  }

  const handleDialogClose = () => {
    if (selectedRow) {
      const storageKey = getStorageKey(gsupplyConfirm, selectedRow.id);
      setLocalStorageWithExpiry(storageKey, selected, TTL_1WEEK);
    }

    // TODO : 수정한 것이 있다면 닫기 전 confirm 창 띄울 것
    setOpen(false);

    initDialog();
  };
  
  const dispatch = useDispatch();
  const location = useLocation();
  const folderSource = location.pathname === '/g04docuGenerateFileNew';

  const sessionUser = useSelector(state => state.session.sessionUser);
  const gstandards = useSelector(state => state.gstandard.gstandards);

  // 데이터 관리
  
  // no dispatch
  const generateDirect = (treeData, gprojectId) => g04docuFileActions.generateDirect(treeData, gprojectId)
  const makeMaterialApproval = ({ docType, gclientId, gclient, gprojectId, gproject, generatedInformation, generatedInformationWithDocus, generatedInformationForPdfs, excluded, fileName, comments, generateOptions, domesticAuths }) => g04docuMaterialApprovalActions.makeMaterialApproval({ docType, gclientId, gclient, gprojectId, gproject, generatedInformation, generatedInformationWithDocus, generatedInformationForPdfs, excluded, fileName, comments, generateOptions, domesticAuths })
  const selectAllGClientsDirect = () => gclientActions.selectAllDirect() // TODO : 회원사 정보 조회를 다이얼로그가 나타날 때 해야 할 것으로 보임
  const selectDirect = (id) => gsupplyConfirmActions.selectDirect(id);

  // dispatch
  const selectOpenedAboutMeGClientListDirect = (service, gclientId) => securityActions.selectOpenedAboutMeGClientListDirect(service, gclientId)
  const createSecurityRequest = ({ id, senderId, receiverId, service, status }) => dispatch(securityRequestActions.create({ id, senderId, receiverId, service, status }))
  const modifySecurityRequest = ({ id, senderId, receiverId, service, status }) => dispatch(securityRequestActions.modify({ id, senderId, receiverId, service, status }))
  const selectGClientsBySecurityRequestStatusByQueryDirect = ({ senderId, receiverIds }) => securityRequestActions.selectGClientsBySecurityRequestStatusByQueryDirect({ senderId, receiverIds });
  const selectAllGSupplyConfirmsDirect = ({ searchType, gprojectId, status }) => gsupplyConfirmActions.selectAllDirect({ searchType, gprojectId, status })

  const sortByOrder = (a, b) => { // 정렬되어 있는 순서대로 정렬(order 필드값)
    const { order : value1 } = a;
    const { order : value2 } = b;
    if (value1 < value2) return -1;
    if (value1 > value2) return 1;
    return 0;
  }

  const sortByName = (a, b) => { // 이름 순서대로 정렬(name 필드값)
    const { name : value1 } = a;
    const { name : value2 } = b;
    if (value1 < value2) return -1;
    if (value1 > value2) return 1;
    return 0;
  }

  /** 프로젝트에서 고른 규격만. 두께가 있으면 그 값, 없으면 레거시 필름 두께 목록. */
  const selectedSpecChoices = (spec) => {
    const thickness = String(spec?.projectThickness || '').trim();
    if (thickness) return [{ key: thickness, label: thickness, code: thickness }];
    const specifics = Array.isArray(spec?.gcomponentItemsSpecific) ? spec.gcomponentItemsSpecific : [];
    return specifics.map((specific) => {
      const code = String(specific?.code || specific?.name || '').trim();
      const label = String(specific?.name || specific?.code || '').trim();
      if (!label) return null;
      return { key: specific.id || code, label, code: code || label };
    }).filter(Boolean);
  };

  /** 부자재 성적서: 인증규격 > 제품 > 고른 규격. */
  const subMaterialProductNodes = (certNodeId, specs, gclientId, division) => {
    const groups = [];
    (specs || []).forEach((spec) => {
      const productName = String(spec?.name || '').trim() || '제품';
      let group = groups.find((row) => row.name === productName);
      if (!group) {
        group = { name: productName, spec, choices: [] };
        groups.push(group);
      }
      selectedSpecChoices(spec).forEach((choice) => {
        if (!group.choices.some((row) => row.code === choice.code)) group.choices.push(choice);
      });
    });
    return groups.map((group) => {
      const productId = `${certNodeId}/${group.spec.id || group.name}`;
      const folderId = group.spec.productFolderId || group.spec.folderId || null;
      const node = {
        id: productId,
        label: group.name,
        type: 'ITEM',
        data: {
          name: group.name,
          code: group.spec.code,
          gclientId,
          id: group.spec.id,
          division,
          productFolderId: group.spec.productFolderId || null,
          folderId,
          folderSource: Boolean(folderSource && folderId),
          g04docuGCertificationId: group.spec.g04docuGCertificationId,
        },
      };
      if (group.choices.length) {
        node.children = group.choices.map((choice) => ({
          id: `${productId}/spec/${choice.key}`,
          label: choice.label,
          type: 'DOCTEST',
          data: {
            code: choice.code,
            name: choice.label,
            productFolderId: group.spec.productFolderId || null,
            folderId,
            folderSource: Boolean(folderSource && folderId),
            division,
            gclientId,
          },
        }));
      }
      return node;
    });
  };

  const compositeTreeItems = (itemsByDivision, itemsForTree, relatedGClients, securityOpenedGClientsAboutMe, gclients, division) => { // 코드 분석할 때 아래 구조와 /g04docuFiles/generate' API와 매칭해서 볼 것
    const isSubMaterial = division === 'SUB_MATERIAL_PROCESS' || division === 'SUB_MATERIAL_BUILD';
    itemsByDivision.forEach(item => {
      const { gclientId, items } = item;
      console.log(items)
      
      const gclient = gclients.find(gc => gc.id === gclientId); // 새로 조회한 거래선 정보를 이용함

      if (!relatedGClients.find(gc => gc.id === gclient.id)) {
        relatedGClients.push(gclient);
      }

      if (gclient) {
        gclient.opened = SecurityUtils.isPublicAbountMe(gclient.id, securityOpenedGClientsAboutMe)
      }

      const gprojectId = selectedRow.id;

      const treeItem = {
        id: `${division}/${gprojectId}/${gclientId}`,
        label: `${gclient.name}:${items.sort(sortByOrder).map(i => (i.itemType === 'RAW_MATERIAL' ? GlassUtils.getMaterialItemCodeOrName('GLASS PRODUCT NAME', i.name) : i.name)).join(",")}`, // :와 ,로 분리하여 거래선명과 mui Chip으로 목록 표시
        type: 'CLIENT', // 거래선과 아이템 목록
        data: { gclientId, gclient },
        children: [
          {
            id: `${division}/${gprojectId}/${gclientId}/general`, // 트리에서 각 노드는 유일한 id를 가져야 하므로 [상위 id/현재 id]로 구성 ('/'를 연결자로 사용)
            label: "일반서류",
            type: 'GENERALS', // 일반서류
            data: {
              folderSource: Boolean(folderSource),
            },
          },
          {
            id: `${division}/${gprojectId}/${gclientId}/certification`,
            label: "인증서",
            type: 'CERTIFICATIONS', // 인증서
            /**
             * 1. g04docuGCertificationIds와 g04docuGCertifications를 생성할 때 items.flatMap()을 사용하여 모든 가능한 인증서 ID를 수집
             * 2. 각 항목에 대해 메인 인증서 ID (i.g04docuGCertificationId), 스펙 내의 인증서 ID (i.specs의 각 항목의 g04docuGCertificationId), 그리고 추가 인증서 ID (i.g04docuGCertificationAdditional)를 모두 고려
             * 3. g04docuGCertifications에서는 각 인증서 ID에 대해 적절한 selectedClassifications를 매핑. 메인 인증서의 경우 모든 스펙의 selectedClassifications를 사용하고, 스펙 내 인증서의 경우 해당 스펙의 selectedClassifications를 사용
             * 4. 추가 인증서의 경우 빈 selectedClassifications 배열을 사용
             * 시가공부자재를 포함한 모든 항목의 인증서 정보를 올바르게 수집
             */
            data: {
              folderSource: Boolean(folderSource),
              /**
               * 강화유리(힛속), 이맥스 관련 인증서, LX클럽 추가
               * g04docuGCertificationAdditional 구조 변경 
               *  - 객체 : 추가 인증서가 하나라고 가정했을 때의 구조 (이전)
               *  - 배열 : 추가 인증서가 여러 개일 경우 (현재)
               */
              g04docuGCertificationIds:
                items.flatMap(i => {
                  const mainCertIds = i.g04docuGCertificationId ? [i.g04docuGCertificationId] : [];
                  const specCertIds = i.specs ? i.specs.map(spec => spec.g04docuGCertificationId).filter(Boolean) : [];
                  const additionalCertIds = i.g04docuGCertificationAdditional
                    ? (Array.isArray(i.g04docuGCertificationAdditional)
                        ? i.g04docuGCertificationAdditional.map(cert => cert.id)
                        : [i.g04docuGCertificationAdditional.id])
                    : [];
                  return [...mainCertIds, ...specCertIds, ...additionalCertIds];
                }),
              g04docuGCertifications:
                items.flatMap(i => {
                  const mainCert = i.g04docuGCertificationId
                    ? [{
                        g04docuGCertificationId: i.g04docuGCertificationId,
                        gstandardId: null,
                        gstandardNo: null,
                        selectedClassifications: i.specs ? i.specs.flatMap(spec => spec.selectedClassifications || []) : [],
                      }]
                    : [];
                  const specCerts = i.specs
                    ? i.specs.filter(spec => spec.g04docuGCertificationId).map(spec => ({
                        g04docuGCertificationId: spec.g04docuGCertificationId,
                        // 가공부자재, 시공부자재에서 표준번호 필요 (중복된 경우 인증서를 하나로 합치기 위해)
                        gstandardId: i.gstandardId,
                        gstandardNo: i.gstandardNo,
                        selectedClassifications: spec.selectedClassifications || [],
                      }))
                    : [];
                  const additionalCerts = i.g04docuGCertificationAdditional
                    ? (Array.isArray(i.g04docuGCertificationAdditional)
                        ? i.g04docuGCertificationAdditional.map(cert => ({
                            g04docuGCertificationId: cert.id,
                            gstandardId: null,
                            gstandardNo: null,
                            selectedClassifications: [],
                          }))
                        : [{
                            g04docuGCertificationId: i.g04docuGCertificationAdditional.id,
                            selectedClassifications: [],
                          }])
                    : [];
                  // console.log({ mainCert, specCerts, additionalCerts })
                  return [...mainCert, ...specCerts, ...additionalCerts];
                }),
            },
          },
          {
            id: `${division}/${gprojectId}/${gclientId}/test`,
            label: "성적서",
            type: 'TESTS', // 성적서
            children: [
              ...items.sort(sortByOrder)?.map(i => {
                const { itemType, specs } = i;
                return {
                  id: `${division}/${gprojectId}/${gclientId}/test/${i.id}`,
                  label: itemType === 'RAW_MATERIAL' ? GlassUtils.getMaterialItemCodeOrName('GLASS PRODUCT NAME', i.name) : i.name,
                  type: 'ITEM',
                  data: { // TODO : 추후 불필요한 데이터 제거하여 경량화 필요
                    ...i,
                    itemType: itemType || (isSubMaterial ? division : itemType),
                    specs: [], // 경량화 필요. 아래의 children에 specs 데이터가 대부분 들어감
                    gclientId,
                  },
                  /**
                   * sortByOrder 대신 sortByName 사용
                   * 성적서 세부 스펙 트리 노드는 거래선별로 설정한 성적서 순서가 아닌 이름순임
                   * 거래선별로 성적서 정렬순서가 다르며, 여기서는 아직 거래선정보로 정렬순서를 가져오기 전임. 물론 거래선별로의 정렬상태로 할 수도 있으나 이름정렬이 더 부합함
                   */
                  children: isSubMaterial
                    ? subMaterialProductNodes(`${division}/${gprojectId}/${gclientId}/test/${i.id}`, specs, gclientId, division)
                    : i.specs?.sort(sortByName)?.map(spec => {
                    // 시가공부자재 => specs: [{ id, gId, code, name, comments, g04docuGCertificationId }]
                    const { name, code, subCode, elements, selectedClassifications, performanceData, g04docuGCertificationCode, gcomponentItemsSpecific, type, subType, folderId } = spec;
                    const baseNode = {
                      id: `${division}/${gprojectId}/${gclientId}/test/${i.id}/${spec.id}`,
                      label: name,
                      type: (itemType === 'SUB_MATERIAL_PROCESS' || itemType === 'SUB_MATERIAL_BUILD') ? 'ITEM'/* 제품. 하위 children에 성적서 추가 */ : 'DOCTEST'/* 성적서 */,
                      data: {
                        name,
                        code: (type === 'TEMPERED' && subType === 'Heat_Soak_Test')
                          ? removeHSTFromCode(code)
                          : code,
                        subCode: itemType === 'PROCESS' ? subCode : null,
                        gclientId,
                        id: spec.id,
                        elements: itemType === 'PROCESS' ? elements : null,
                        division: itemType,
                        selectedClassifications,
                        gcomponentItemId: itemType === 'PROCESS' ? "" : i.id,
                        gcomponentItemName: itemType === 'PROCESS' ? "" : i.gcomponentItemName,
                        g04docuGCertificationId: i.g04docuGCertificationId,
                        g04docuGCertificationName: i.g04docuGCertificationName,
                        performanceData,
                        productFolderId: spec.productFolderId || i.productFolderId || null,
                        folderId: folderId || null,
                        folderSource: Boolean(folderSource && (itemType === 'PROCESS' || (itemType === 'RAW_MATERIAL' && (spec.productFolderId || i.productFolderId)))),
                      }
                    };

                    // 원판은 자재에 스펙까지를 노드로 구성(예: CL - 5T)하면 성적서를 붙여주는 방식
                    // 이와는 다르게 시가공부자재의 경우 노드를 여기(위-자재)까지만 구성하면 서버에서 하위 children에 성적서를 추가해줌 (자재별로 하위 스펙없이 G04docuGTest에 등록되어 있는 성적서 목록)
                    // 그러나 그중 특이하게도 접합필름의 경우 유리원판처럼 스펙(두께)이 있어 화면에서 추가 하위 노드를 생성하고 서버에서는 여기에 성적서를 붙여주는 방식으로 함
                    const projectThickness = String(spec.projectThickness || '').trim();
                    const projectProductName = String(spec.projectProductName || '').trim();
                    if ((itemType === 'SUB_MATERIAL_PROCESS' || itemType === 'SUB_MATERIAL_BUILD') && projectThickness) {
                      const specLabel = [projectThickness, projectProductName].filter(Boolean).join(' ');
                      baseNode.children = [{
                        id: `${baseNode.id}/spec/${projectThickness}`,
                        label: specLabel,
                        type: 'DOCTEST',
                        data: {
                          code: projectThickness,
                          name: specLabel,
                          productFolderId: spec.productFolderId || null,
                          folderId: spec.productFolderId || null,
                          folderSource: Boolean(folderSource),
                          division: itemType,
                          gclientId,
                        },
                      }];
                    } else if (g04docuGCertificationCode === "LAMINATED_FILM" && gcomponentItemsSpecific && gcomponentItemsSpecific.length > 0) {
                      console.log('gcomponentItemsSpecific', gcomponentItemsSpecific)
                      baseNode.children = gcomponentItemsSpecific
                        .sort((a, b) => (a.order || 0) - (b.order || 0)) // order로 정렬
                        .map((specific) => ({
                          id: `${baseNode.id}/specific/${specific.id}`,
                          label: specific.name,
                          type: 'DOCTEST', // 성적서
                          data: {
                            ...specific,
                            parentId: baseNode.id
                          }
                        }));
                    }
                    
                    return baseNode;
                  })
                }
              })
            ]
          },
          {
            id: `${division}/${gprojectId}/${gclientId}/etc`,
            label: "기타",
            type: 'ETCS',
          }
        ]
      };
      
      itemsForTree.push(treeItem);
      console.log(itemsForTree)
    })
  }

  const getGSupplyConfirmData = async (gsupplyConfirms) => {
    const tableData = [];

    let categoryCount = {
      '가공유리': 0,
      '가공부자재': 0,
      '시공부자재': 0
    };

    let noCount = {};

    // 가공유리 데이터 구조화
    selectedRow.selectedGlasses?.forEach(glass => {
      const glassSpecs = glass.selectedGcomponentItems?.reduce((acc, items) => {
        const productNameItem = items?.find(item => item.code === 'GLASS PRODUCT NAME');
        const thicknessItem = items?.find(item => item.code === 'GL THICKNESS');
        
        if (productNameItem && thicknessItem) {
          const spec = {
            name: `${thicknessItem.value.code} ${productNameItem.value.code}`.replace(/\(.*?\)/, ""),
            manufacturers: productNameItem.value.gclients || [],
            gcomponentItemId: productNameItem.value.id,
            gcomponentAttId: thicknessItem.value.id,
          };
          if (!acc.some(s => s.name === spec.name)) {
            acc.push(spec);
          }
        }
        return acc;
      }, []);

      // noCount 계산
      if (!noCount[glass.no]) {
        noCount[glass.no] = glassSpecs.length;
      }

      const processClients = glass.selectedProcessGClients?.[glass.selectedProcessGClients.length - 1]?.selectedGClients || [];

      glassSpecs.forEach((spec, index) => {
        categoryCount['가공유리']++;

        tableData.push({
          category: '가공유리',
          isFirstInCategory: categoryCount['가공유리'] === 1,
          no: glass.no,
          isFirstInNo: !tableData.some(item => item.no === glass.no),
          noRowSpan: noCount[glass.no],
          specification: index === 0 ? glass.specification.replaceAll("|", " ").replaceAll("+", " + ") : '',
          company: index === 0 ? processClients.map(client => client.name).join(', ') : '',
          gclientId: index === 0 ? processClients.map(client => client.id).join(',') : '',
          gcomponentItemId: spec.gcomponentItemId,
          gcomponentAttId: spec.gcomponentAttId,
          productName: spec.name,
          appliedArea: glass.appliedArea,
          manufacturer: spec.manufacturers.map(m => m.name).join(', '),
          manufacturerId: spec.manufacturers.map(m => m.id).join(','),
          rowSpan: index === 0 ? glassSpecs.length : 0
        });
      });
    });
  
    // 가공부자재 데이터 구조화 수정
    selectedRow.selectedSubMaterialProcessItems?.filter(item => Object.keys(item.value).length > 0)
    .forEach((item) => {
      console.log(item);

      if (item.code === 'LAMINATED_FILM' && Array.isArray(item.value.gcomponentItemsSpecific)) {
        // 접합필름인 경우
        item.value.gcomponentItemsSpecific.forEach((specific, index) => {
          categoryCount['가공부자재']++;
 
          // const productName = `${item.value.name} (${specific.name})`;
          const productName = `${specific.code} ${item.value.name}`;
          
          tableData.push({
            category: '가공부자재',
            isFirstInCategory: categoryCount['가공부자재'] === 1,
            no: item.name,
            isFirstInNo: index === 0,
            noRowSpan: item.value.gcomponentItemsSpecific.length,
            specification: productName, // 각 행마다 제품명 표시
            company: item.value.gclients?.map(client => client.name).join(', '), // 각 행마다 업체명 표시
            gclientId: item.value.gclients?.[0]?.id,
            gcomponentItemId: item.value.id,
            gcomponentAttId: specific.id,
            g04docuGCertificationId: item.id,
            productName: '해당없음', // 원판은 해당없음으로 표시
            manufacturer: '해당없음',
            rowSpan: 1, // 각 행을 개별적으로 표시하므로 rowSpan은 1
            isSubMaterial: true
          });
        });
      } else { // 접합필름이 아닌 경우 기존 로직
        categoryCount['가공부자재']++;
        
        tableData.push({
          category: '가공부자재',
          isFirstInCategory: categoryCount['가공부자재'] === 1,
          no: item.name,
          isFirstInNo: true,
          noRowSpan: 1,
          specification: item.value.name,
          company: item.value.gclients?.map(client => client.name).join(', '),
          gclientId: item.value.gclients?.[0]?.id,
          gcomponentItemId: item.value.id,
          gcomponentAttId: '',
          g04docuGCertificationId: item.id,
          productName: '해당없음',
          manufacturer: '해당없음',
          rowSpan: 1,
          isSubMaterial: true
        });
      }
    });

    // 시공부자재 데이터 구조화 수정
    selectedRow.selectedSubMaterialBuildItems?.filter(item => Object.keys(item.value).length > 0)
    .forEach((item) => {
      categoryCount['시공부자재']++;

      tableData.push({
        category: '시공부자재',
        isFirstInCategory: categoryCount['시공부자재'] === 1,
        no: item.name,
        isFirstInNo: true,
        noRowSpan: 1,
        specification: item.value.name,
        company: item.value.gclients?.map(client => client.name).join(', '),
        gclientId: item.value.gclients?.[0]?.id,
        gcomponentItemId: item.value.id,
        gcomponentAttId: '',
        g04docuGCertificationId: item.id,
        productName: '해당없음',
        manufacturer: '해당없음',
        rowSpan: 1,
        isSubMaterial: true
      });
    });

    // 각 카테고리의 첫 번째 행에 전체 rowSpan 설정
    const newTableData = tableData.map(row => {
      if (row.isFirstInCategory) {
        row.categoryRowSpan = categoryCount[row.category];
      }
      return row;
    });
    console.log(newTableData);
    
    const requestSummary = [];
      
    // 원판 데이터 처리
    const rawGlassProducts = new Map(); // Set을 Map으로 변경하여 업체명 정보도 저장
    newTableData.forEach(row => {
      if (row.category === '가공유리' && row.productName !== '-') {
        rawGlassProducts.set(row.productName, {
          manufacturer: row.manufacturer,
          manufacturerId: row.manufacturerId,
          gcomponentItemId: row.gcomponentItemId,
          gcomponentAttId: row.gcomponentAttId
        });
      }
    });
    
    rawGlassProducts.forEach((value, product) => {
      requestSummary.push({
        category: '원자재',
        subCategory: '원판',
        company: value. manufacturer, // 원판제조사를 업체명으로 설정
        gclientId: value.manufacturerId, // manufacturerId 추가
        gcomponentItemId: value.gcomponentItemId,
        gcomponentAttId: value.gcomponentAttId,
        product: product,
        itemCode: '',
        appliedArea: '',
        supplySize: '',
        supplyUnit: 'EA',
        supplyDate: '',
        // note: '',
        // etc: ''
      });
    });
  
    // 가공유리 데이터 처리 - 업체별로 그룹화
    const processedGlassMap = new Map(); // 업체별 가공유리 데이터 저장

    newTableData.forEach(row => {
      if (row.category === '가공유리' && row.specification) {
        const gclientIds = row.gclientId.split(',').map(id => id.trim());
        const companies = row.company.split(',').map(name => name.trim());
        
        companies.forEach((company, idx) => {
          const key = `${company}-${gclientIds[idx]}`;
          if (!processedGlassMap.has(key)) {
            processedGlassMap.set(key, []);
          }
          
          processedGlassMap.get(key).push({
            category: '가공유리',
            subCategory: row.no,
            company: company,
            gclientId: gclientIds[idx],
            gcomponentItemId: row.gcomponentItemId,
            gcomponentAttId: row.gcomponentAttId,
            product: row.specification,
            itemCode: '',
            appliedArea: row.appliedArea,
            supplySize: '',
            supplyUnit: 'EA',
            supplyDate: '',
            // note: '',
            // etc: ''
          });
        });
      }
    });

    // 그룹화된 가공유리 데이터를 requestSummary에 추가
    processedGlassMap.forEach(items => {
      requestSummary.push(...items);
    });
  
    // 가공부자재 데이터 처리
    newTableData.forEach(row => {
      if (row.category === '가공부자재') {
        requestSummary.push({
          category: '가공부자재',
          subCategory: row.no,
          company: row.company, // 업체명 추가
          gclientId: row.gclientId,
          gcomponentItemId: row.gcomponentItemId,
          gcomponentAttId: row.gcomponentAttId,
          // g04docuGCertificationId: row.g04docuGCertificationId,
          product: row.specification,
          itemCode: '',
          appliedArea: '',
          supplySize: '',
          supplyUnit: 'EA',
          supplyDate: '',
          // note: '',
          // etc: ''
        });
      }
    });
  
    // 시공부자재 데이터 처리
    newTableData.forEach(row => {
      if (row.category === '시공부자재') {
        requestSummary.push({
          category: '시공부자재',
          subCategory: row.no,
          company: row.company, // 업체명 추가
          gclientId: row.gclientId,
          gcomponentItemId: row.gcomponentItemId,
          gcomponentAttId: row.gcomponentAttId,
          // g04docuGCertificationId: row.g04docuGCertificationId,
          product: row.specification,
          itemCode: '',
          appliedArea: '',
          supplySize: '',
          supplyUnit: 'EA',
          supplyDate: '',
          // note: '',
          // etc: ''
        });
      }
    });
  
    console.log(requestSummary);

    const fetchConfirmedItems = async () => {
      const confirmDetails = [];
      try {
        for (const confirm of gsupplyConfirms) {
          const result = await selectDirect(confirm.id);
          confirmDetails.push(result);
        }
      
        console.log(requestSummary, confirmDetails);
        // summaryData를 업데이트
        const updatedData = requestSummary.map(summaryItem => {
          // 원자재인 경우와 그렇지 않은 경우를 구분
          if (summaryItem.category === '원자재') {
            const matchingConfirm = confirmDetails.find(confirm => 
              confirm.items?.some(item => 
                item.gclientId === summaryItem.gclientId &&
                item.gcomponentAttId === summaryItem.gcomponentAttId &&
                item.gcomponentItemId === summaryItem.gcomponentItemId
              )
            );
            
            const matchingItem = matchingConfirm?.items?.find(item => 
              item.gclientId === summaryItem.gclientId &&
              item.gcomponentAttId === summaryItem.gcomponentAttId &&
              item.gcomponentItemId === summaryItem.gcomponentItemId
            );
            return {
              ...summaryItem,
              itemCode: matchingItem?.itemCode || '',
              appliedArea: matchingItem?.appliedArea || '',
              supplySize: matchingItem?.supplySize || '',
              supplyUnit: matchingItem?.supplyUnit || '',
              supplyDate: matchingItem?.startDate
              ? `${matchingItem.startDate.slice(0, 10)} ~ ${matchingItem.endDate?.slice(0, 10) || matchingItem.startDate.slice(0, 10)}`
              : '',
            };
          } else if (summaryItem.category === '가공유리') {
            const matchingConfirm = confirmDetails.find(confirm => 
              confirm.items?.some(item => 
                item.gclientId === summaryItem.gclientId &&
                item.gprojectGlassesNo === summaryItem.subCategory
              )
            );
            
            const matchingItem = matchingConfirm?.items?.find(item => 
              item.gclientId === summaryItem.gclientId &&
              item.gprojectGlassesNo === summaryItem.subCategory
            );
            return {
              ...summaryItem,
              itemCode: matchingItem?.itemCode || '',
              appliedArea: matchingItem?.appliedArea || '',
              supplySize: matchingItem?.supplySize || '',
              supplyUnit: matchingItem?.supplyUnit || '',
              supplyDate: matchingItem?.startDate
                ? `${matchingItem.startDate.slice(0, 10)} ~ ${matchingItem.endDate?.slice(0, 10) || matchingItem.startDate.slice(0, 10)}`
                : '',
            };
          } else if (summaryItem.category === '가공부자재' || summaryItem.category === '시공부자재') {  // 시공부자재 케이스 추가
            const matchingConfirm = confirmDetails.find(confirm => 
              confirm.items?.some(item => 
                // 접합필름인 경우 gcomponentAttId도 함께 확인
                (summaryItem.subCategory === '접합필름' 
                  ? item.gclientId === summaryItem.gclientId &&
                    item.gcomponentItemId === summaryItem.gcomponentItemId && 
                    item.gcomponentAttId === summaryItem.gcomponentAttId
                  : item.gclientId === summaryItem.gclientId &&
                    item.gcomponentItemId === summaryItem.gcomponentItemId)
              )
            );
            
            const matchingItem = matchingConfirm?.items?.find(item => 
              // 접합필름인 경우 gcomponentAttId도 함께 확인
              (summaryItem.subCategory === '접합필름'
                ? item.gclientId === summaryItem.gclientId &&
                  item.gcomponentItemId === summaryItem.gcomponentItemId && 
                  item.gcomponentAttId === summaryItem.gcomponentAttId
                : item.gclientId === summaryItem.gclientId &&
                  item.gcomponentItemId === summaryItem.gcomponentItemId)
            );
            
            return {
              ...summaryItem,
              itemCode: matchingItem?.itemCode || '',
              appliedArea: matchingItem?.appliedArea || '',
              supplySize: matchingItem?.supplySize || '',
              supplyUnit: matchingItem?.supplyUnit || '',
              supplyDate: matchingItem?.startDate
                ? `${matchingItem.startDate.slice(0, 10)} ~ ${matchingItem.endDate?.slice(0, 10) || matchingItem.startDate.slice(0, 10)}`
                : '',
            };
          }
        });
        console.log(updatedData);
        return updatedData;
      } catch (error) {
        console.error('Failed to fetch gsupplyConfirmItems:', error);
      } finally {
        
      }
    };
    
    const newRequestSummary = await fetchConfirmedItems();

    setGSupplyConfirmSummaryData(newRequestSummary);
    setGSupplyConfirmSummaryFilteredData(newRequestSummary);

    return newRequestSummary;
  };

  useEffect(
    async () => {
      if (open && selectedRow && gcertifications) {
        regenerate(selectedRow, gcertifications);
      }
    }, [gsupplyConfirm, open]
  );

  const pasteStandardNo = (data) => {
    console.log(gcertifications)
    const processNode = (node) => {
      if (node.type === 'DOCCERTIFICATION' || node.type === 'DOCTEST') {
        if (!node.data) {
          node.data = {};
        }
        const gstandardNo = gcertifications.find(gcertification => gcertification.id === node.data.g04docuGCertificationId)?.gstandardNo
        node.data.gstandardNo = (gstandardNo?.indexOf('KS') === 0 || gstandardNo?.indexOf('SPS') === 0) && gstandardNo;
      }

      if (node.children && Array.isArray(node.children)) {
        node.children.forEach(child => processNode(child));
      }
    };

    if (data && Array.isArray(data)) {
      data.forEach(node => processNode(node));
    }
    return data;
  };
        
  
  const regenerate = async (selRow, gcertifications) => {
    if (selRow) {
      setBuildingToc(true);
      try {
      // TODO : 여기서 최신의 회원사 정보를 조회하여 사용하는게 맞겠다.
      const newGClients = await selectAllGClientsDirect();

      const relatedGClients = [];
      console.log(selRow);
      // const gdomesticAuths = [];
      const rawMaterialItemsForTree = [];
      const processItemsForTree = [];
      const subMaterialProcessItemsForTree = [];
      const subMaterialBuildItemsForTree = [];
      if (selRow) {
        const service = '04docu';
        const securityOpenedGClientsAboutMe = await selectOpenedAboutMeGClientListDirect(service, sessionUser.id);

        const { selectedGlasses, selectedSubMaterialProcessItems, selectedSubMaterialBuildItems } = selRow;
        console.log(selectedGlasses);
        if (selectedGlasses && selectedGlasses.length > 0) {
          const gcomponentItems = []; // 원자재용
          const processItems = []; // 가공용
          const glasses = JSON.parse(JSON.stringify(selectedGlasses)); // TODO : 변환 필요한건지 추후 검토
          const gclientIds = [];
          
          // 1. 원자재
          glasses.forEach(glass => {
            glass.selectedGcomponentItems.forEach((gtypeDetails, i) => {
              let thickness = []; // 각 레이어에서 유리 두께는 하나임
              gtypeDetails.forEach((item, j) => {
                const items = [];
                // 각 레이어의 첫번째는 상세 구성요소의 상위 개념 (예를 들면 유리원판, 중공층 등...)으로 스킵
                if (j === 0) {
                  return;
                }

                // console.log(item);
                if (item.code === 'GL THICKNESS') { // 유리 두께일 경우
                  // thickness.push(item);
                  thickness.push(item.value);
                }

                // 2024.08.07 원자재는 유리원판에 대해서만 모은다. 기존에는 제조사가 있는 제품(예를 들면 접합필름 등)이 원자재에 보이는 문제가 있었음
                if (item.code === 'GLASS PRODUCT NAME' && item.value?.selectedGClientId) { // 해당 아이템의 제조사를 선택한 경우 (제조사 선택을 하지 않으면 목록에서 빠짐)
                  const ele = gclientIds.find(id => id === item.value?.selectedGClientId)
                  console.log(item.value)
                  const { id, gcomponentId, code, name, comments, g04docuGCertificationId, g04docuGCertificationName, selectedClassifications, itemType, order } = item.value;
                  if (!ele) {
                    gclientIds.push(item.value.selectedGClientId); // 같은 거래선의 아이템끼리 묶기 위해 사용
                    // 같은 아이템이 있으면 pass. TODO : 이 코드가 필요한가??? 거래선이 없어서 처음 추가한 거라면 거래선 하위에 아이템도 없을 것이고 위 반복문 (gtypeDetails.forEach((item, j) => {)을 보면 그 하위에 items 배열이 있으므로 늘 같은 아이템은 없어보임
                    // const sameItem = items.find(i => i.id === id);
                    // if (!sameItem) {
                      if (item.code === 'GLASS PRODUCT NAME') {
                        console.log(item.value)
                        items.push({ id, gcomponentId, code, name, gcomponentItemName: name, comments, g04docuGCertificationId, g04docuGCertificationName, specs: thickness.map(t => ({ ...t, selectedClassifications, productFolderId: item.value.productFolderId || null })), itemType, order, productFolderId: item.value.productFolderId || null });
                      }/* else {
                        items.push({ id, gcomponentId, code, name, comments, g04docuGCertificationId, itemType }); // TODO : 원판이 아닌 경우 이 코드가 필요한가?
                      }*/
                    // }

                    gcomponentItems.push({
                      gclientId: item.value.selectedGClientId,
                      // 임시 : gclient 필요정보 점검
                      // gclient: item.value.gclients.find(gclient => gclient.gclient.id === item.value.selectedGClientId)?.gclient,
                      gclient: item.value.gclients.find(gclient => gclient.id === item.value.selectedGClientId),
                      items,
                    });
                  } else if (ele) {
                    // if (!gcomponentItems[gcomponentItems.length - 1].items.find(i => i.id === id)) { // TODO : 맨 마지막이 맞음??? 틀리네... 해당 거래선을 찾아야 함
                    //   gcomponentItems[gcomponentItems.length - 1].items.push({ id, /*gId*/gcomponentId, code, name, comments, g04docuGCertificationId });
                    // } else {
                    //   // "유리 원판 제품명"일 경우 유리두께 정보를 배열로 추가해야 한다.
                    //   if (item.code === 'GLASS PRODUCT NAME') {
                    //     // gcomponentItems[gcomponentItems.findIndex(g => g.)].items.push({ id, /*gId*/gcomponentId, code, name, comments, g04docuGCertificationId });
                    //   }
                    // }
                    gcomponentItems.forEach(gcomponentItem => {
                      if (gcomponentItem.gclientId === item.value.selectedGClientId) {
                        // console.log(gcomponentItem.items.find(i => i.id === id))
                        // if (!gcomponentItem.items.find(i => i.id === id)) {
                        if (!gcomponentItem.items.find(i => i.id === id) && item.code === 'GLASS PRODUCT NAME') {
                          // gcomponentItem.items.push({ id, gcomponentId, code, name, comments, g04docuGCertificationId });
                          gcomponentItem.items.push({ id, gcomponentId, code, name, gcomponentItemName: name, comments, g04docuGCertificationId, g04docuGCertificationName, specs: thickness.map(t => ({ ...t, selectedClassifications, productFolderId: item.value.productFolderId || null })), itemType, order, productFolderId: item.value.productFolderId || null });
                        } else {
                          gcomponentItem.items.forEach(i => {
                            if (i.id === id && item.code === 'GLASS PRODUCT NAME') {
                              // i.thickness = i.thickness.concat(thickness);
                              if (i.specs.filter(t => t.id === thickness[0].id).length <= 0) {
                                i.specs = i.specs.concat(thickness).map(t => ({ ...t, selectedClassifications, productFolderId: item.value.productFolderId || i.productFolderId || null }));
                              }
                            }
                          })
                        }
                      }
                    })
                  }
                }
              })
            })
          })

          console.log({ gcomponentItems })
          compositeTreeItems(gcomponentItems, rawMaterialItemsForTree, relatedGClients, securityOpenedGClientsAboutMe, newGClients, 'RAW_MATERIAL'); // TODO : 임시주석

          // 2. 가공
          gclientIds.splice(0, gclientIds.length); // 배열 비우기
          glasses.forEach(glass => {
            const { selectedProcessGClients } = glass;
            console.log(selectedProcessGClients)
            // const certificationsOnly = selectedProcessGClients.filter(process => process.certificationOnly === true);
            // console.log(certificationsOnly)
            selectedProcessGClients?.forEach(process => {
              const { selectedGClients, specification, specificationByGStandard, g04docuGCertification, g04docuGCertificationAdditional, specificationElements, type, subType, performanceData } = process;
              if (type === 'ONE_PANE') {
                return;
              }
              
              selectedGClients?.forEach(gclient => {
                const ele = processItems.find(processItem => processItem.gclientId === gclient.id);
                const { id, name, code, order, selectedClassifications } = g04docuGCertification;
                if (!ele) {
                  processItems.push({
                    gclientId: gclient.id,
                    gclient,
                    items: [{
                      id,
                      name,
                      code,
                      g04docuGCertificationId: id,
                      g04docuGCertificationName: name,
                      g04docuGCertificationAdditional,
                      itemType: 'PROCESS',
                      specs: [{
                        id: specification,
                        name: specification.replaceAll("|", " ").replaceAll("+", " + "),
                        code: (type === 'TEMPERED' && subType === 'Heat_Soak_Test')
                          ? removeHSTFromCode(specification)
                          : specification,
                        subCode: specificationByGStandard,
                        elements: specificationElements,
                        selectedClassifications: selectedClassifications,
                        performanceData, // 성능확인서 추가
                      }],
                      order,
                    }],
                  });
                } else {
                  processItems.forEach(processItem => {
                    if (processItem.gclientId === gclient.id) {
                      const index = processItem.items.findIndex(i => i.id === id);
                      if (index === -1) {
                        processItem.items.push({
                          id,
                          name,
                          code,
                          g04docuGCertificationId: id,
                          g04docuGCertificationName: name,
                          g04docuGCertificationAdditional,
                          itemType: 'PROCESS',
                          specs: [{
                            id: specification,
                            name: specification.replaceAll("|", " ").replaceAll("+", " + "),
                            code: (type === 'TEMPERED' && subType === 'Heat_Soak_Test')
                              ? removeHSTFromCode(specification)
                              : specification,
                            subCode: specificationByGStandard,
                            elements: specificationElements,
                            selectedClassifications: selectedClassifications,
                            performanceData, // 성능확인서 추가
                          }],
                          order,
                        });
                      } else {
                        if (!processItem.items[index].specs.find(t2 => t2.id === specification)) {
                          // TODO : 추후 specs 정렬 필요?
                          processItem.items[index].specs.push({
                            id: specification,
                            name: specification.replaceAll("|", " ").replaceAll("+", " + "),
                            code: (type === 'TEMPERED' && subType === 'Heat_Soak_Test')
                              ? removeHSTFromCode(specification)
                              : specification,
                            subCode: specificationByGStandard,
                            elements: specificationElements,
                            // selectedClassifications: g04docuGCertification.selectedClassifications,
                            selectedClassifications: selectedClassifications,
                            performanceData, // 성능확인서 추가
                            type,
                            subType,
                          });
                        }
                      }
                    }
                  })
                }
              })
            })
          })

          console.log({ processItems });
          compositeTreeItems(processItems, processItemsForTree, relatedGClients, securityOpenedGClientsAboutMe, newGClients, 'PROCESS'); // TODO : 임시주석
        }

        // 3. 가공부자재, 4. 시공부자재
        [1, 2].forEach((element, i) => {
          const selectedSubMaterialItems = JSON.parse(JSON.stringify(i === 0 ? selectedSubMaterialProcessItems.filter(smpi => smpi.usable) : selectedSubMaterialBuildItems.filter(smbi => smbi.usable)));
          if (selectedSubMaterialItems && selectedSubMaterialItems.length > 0) {
            const subMaterialItems = [];
            const gclientIds = [];
            console.log(selectedSubMaterialItems)
            selectedSubMaterialItems.forEach((item, i) => {
              // item 구조
              // id: G04docus.id. 해당 아이템에 연결된 아이디. (GComponentItems 또는 GSubItems의 g04docuId). 참고로 G04docus에서 실제 아이템의 상위이므로 GClientG04docuMaps에는 연결되지 않는다.
              // name : 해당 아이템의 상위 GComponents 또는 GSubs의 name(type = 'group')
              // index : 같은 제품을 여러개 선택할 수 있으므로 구분짓기 위한 인덱스 순서
              // value : 선택한 GComponentItems 또는 GSubItems의 실제 내용. 상세내용은 아래에...
              // usable : 사용여부 (자재승인서류에 포함할지 안할지 체크하는 부분)
              const items = [];
              if (item.value?.selectedGClientId) { // 해당 아이템의 제조사롤 선택한 거래선
                const ele = gclientIds.find(id => id === item.value.selectedGClientId);
                const { id, gId, code, name, comments, g04docuGCertificationId, g04docuGCertificationCode, itemType, gcomponentItemsSpecific } = item.value; // TODO : 해당 아이템과 연결된 GClientG04docuMaps의 g04docuId가 추가적으로 필요함. 실제 문서 관련
              const productFolderId = item.value?.productFolderId || item.value?.folderId || null;
              const subMaterialSpec = () => ({
                id,
                gId,
                code,
                name,
                comments,
                g04docuGCertificationId,
                g04docuGCertificationCode,
                g04docuGCertificationName: item.name,
                gcomponentItemsSpecific: gcomponentItemsSpecific && gcomponentItemsSpecific.length > 0 ? gcomponentItemsSpecific : null,
                folderId: productFolderId,
                productFolderId,
                projectThickness: item.value?.filmThicknessCode || '',
                projectProductName: name || '',
              });
                if (!ele) {
                  // items에 규격, specs에 제품이 들어가도록 한다. => item에 규격정보, item.value가 제품임
                  /**
                   * 근거 : 시가공부자재는 원판이나 가공처럼 "제품 > 스펙" 구조가 아니다. (예, Clear > 3T, 4T, ...)
                   * 그래서 성적서의 계층구조를 유지하면서 시가공부자재의 특성을 고려하여 "규격 > 제품" 구조로 설계
                   * => 자재승인서 구성시 가공부자재/시공부자재 탭에서 부자재 선택할 때 그룹별로 되어 있고 그 안에 제품을 선택하는 것을 상기하면 이해하기 쉬움)
                   * 
                   * (이전) 이럴 경우 성적서 등록 화면에서는 해당 제품에 여러 스펙의 성적서를 등록할 수 있는데 시가공제품의 경우 하나만 등록하게 하거나 여러개 등록 후 대표성적서를 선택하게 하는 방법이 있을 수 있음
                   * => (현재) 복수의 성적서를 등록하도록 변경
                   *  */
                  gclientIds.push(item.value.selectedGClientId); // 같은 거래선의 아이템끼리 묶기 위해 사용

                  items.push({ 
                    id: item.id, 
                    code: item.code, 
                    name: item.name,
                    gstandardId: item.gstandardId,
                    gstandardNo: item.gstandardNo,
                    specs: [subMaterialSpec()], 
                    itemType,
                  });

                  subMaterialItems.push({
                    gclientId: item.value.selectedGClientId,
                    // 임시 : gclient 필요정보 점검
                    // gclient: item.value.gclients.find(gclient => gclient.gclient.id === item.value.selectedGClientId)?.gclient,
                    gclient: item.value.gclients.find(gclient => gclient.id === item.value.selectedGClientId),
                    items,
                  });
                } else if (ele) {
                  subMaterialItems.forEach(subMaterialItem => {
                    if (subMaterialItem.gclientId === item.value.selectedGClientId) { // 같은 거래선(제조사) 하위에 추가
                      const foundItem = subMaterialItem.items.find(smItem => smItem.id === item.id); // 같은 규격(개념적으로 같은 제품군)이면 해당 규격아래로 제품을 추가한다.
                      if (foundItem) {
                        foundItem.specs.push(subMaterialSpec());
                      } else { // 규격이 다르면 새 규격과 제품을 등록한다.
                        subMaterialItem.items.push({
                          id: item.id,
                          // gId: null,
                          code: item.code,
                          name: item.name,
                          // comments: null,
                          // g04docuGCertificationId: null,
                          gstandardId: item.gstandardId,
                          gstandardNo: item.gstandardNo,
                          specs: [subMaterialSpec()],
                        itemType,
                      });
                      }
                    }
                  })
                }
              }
            })

            console.log({ subMaterialItems });
            compositeTreeItems(subMaterialItems, i === 0 ? subMaterialProcessItemsForTree : subMaterialBuildItemsForTree, relatedGClients, securityOpenedGClientsAboutMe, newGClients, i === 0 ? 'SUB_MATERIAL_PROCESS' : 'SUB_MATERIAL_BUILD'); // TODO : 임시주석
          }
        })

        const data = [
          ...(gsupplyConfirm ? [{
            id: 'GSUPPLY_CONFIRM',
            label: '납품확인서',
            type: 'DIVISION',
          }] : []),
          {
            id: 'GMATERIAL_APPROVAL',
            label: '자재승인서 요약',
            type: 'DIVISION1',
          },
          {
            id: 'DOMESTIC_AUTH',
            label: '국내가공유리제품 사전 인증',
            type: 'DIVISION',
          },
          {
            id: 'SUPPLIER',
            label: '공급업체',
            type: 'DIVISION',
          },
          {
            id: 'RAW_MATERIAL',
            label: '원자재',
            type: 'DIVISION',
          },
          {
            id: 'PROCESS',
            label: '가공',
            type: 'DIVISION',
          },
          {
            id: 'SUB_MATERIAL_PROCESS',
            label: '가공부자재',
            type: 'DIVISION',
          },
          {
            id: 'SUB_MATERIAL_BUILD',
            label: '시공부자재',
            type: 'DIVISION',
          },
        ];

        // console.log(sessionUser);
        const { id, name } = sessionUser;
        const gprojectId = selRow.id;

        const gdomesticAuthsForTree = selectedGlasses.map((glass, i) => {
          const { no, gglassId, gglassName, specification, authYN, authName, types, authDocumentPath } = glass;
          const replacedSpecification = specification.replaceAll("|", " ").replaceAll("+", " + ");
          return {
            // id: `${gprojectId}/${i}`,
            id: `DOMESTIC_AUTH/${gprojectId}/${glass.id}`,
            label: `${no}:${gglassName}:${replacedSpecification}`,
            type: 'DOMESTIC_AUTH',
            data: { gclientId: id, /*gclient: { ...sessionUser, opened: true }, */no, gglassId, gglassName, specification: replacedSpecification, authYN, authName, types, authDocumentPath },
          }
        });
        
        const supplierForTree = [{
          id: `SUPPLIER/${gprojectId}/${id}`,
          label: name,
          type: 'CLIENT',
          data: { gclientId: id, gclient: { ...sessionUser, opened: true } },
          children: [
            {
              id: `SUPPLIER/${gprojectId}/${id}/general`, // 트리에서 각 노드는 유일한 id를 가져야 하므로 상위/현재 아이디로 구성 ('/'를 연결자로 사용)
              label: "일반서류",
              data: {
                // gclientId: id,
                // gclient: sessionUser,
                folderSource: Boolean(folderSource),
              },
              type: 'GENERALS',
            },
            // TODO: 공급업체에 인증서나 성적서가 필요한가???
            // {
            //   id: `${gprojectId}/${id}/certification`, // 트리에서 각 노드는 유일한 id를 가져야 하므로 상위/현재 아이디로 구성 ('/'를 연결자로 사용)
            //   label: "인증서",
            //   data: {
            //     // gclientId: id,
            //     // gclient: sessionUser,
            //   },
            //   type: 'CERTIFICATIONS',
            // },
            // {
            //   id: `${gprojectId}/${id}/test`, // 트리에서 각 노드는 유일한 id를 가져야 하므로 상위/현재 아이디로 구성 ('/'를 연결자로 사용)
            //   label: "성적서",
            //   data: {
            //     // gclientId: id,
            //     // gclient: sessionUser,
            //   },
            //   type: 'TESTS',
            // },
            {
              id: `SUPPLIER/${gprojectId}/${id}/etc`, // 트리에서 각 노드는 유일한 id를 가져야 하므로 상위/현재 아이디로 구성 ('/'를 연결자로 사용)
              label: "기타",
              data: {
                // gclientId: id,
                // gclient: sessionUser,
              },
              type: 'ETCS',
            }
          ]
        }];
        
        data.find(i => i.id === 'DOMESTIC_AUTH').children = gdomesticAuthsForTree;
        data.find(i => i.id === 'SUPPLIER').children = supplierForTree;
        data.find(i => i.id === 'RAW_MATERIAL').children = rawMaterialItemsForTree;
        data.find(i => i.id === 'PROCESS').children = processItemsForTree;
        data.find(i => i.id === 'SUB_MATERIAL_PROCESS').children = subMaterialProcessItemsForTree;
        data.find(i => i.id === 'SUB_MATERIAL_BUILD').children = subMaterialBuildItemsForTree;
        
        // const processItems = data.find(i => i.id === 'SUB_MATERIAL_PROCESS');
        // if (processItems) {
        //   processItems.children = subMaterialProcessItemsForTree;
        // }

        // const buildItems = data.find(i => i.id === 'SUB_MATERIAL_BUILD');
        // if (buildItems) {
        //   buildItems.children = subMaterialBuildItemsForTree;
        // }

        // data[2].children = subMaterialProcessItemsForTree;
        // data[3].children = subMaterialBuildItemsForTree;

        // console.log(JSON.stringify(data, null, 2));
        
        const resData = await generateDirect(data, gprojectId);
        // const resData = data;
        console.log('data', data);
        console.log('resData', resData);

        // 스텝 2: DB에서 저장된 대체성적서 정보 가져오기
        console.log('DB에서 대체성적서 정보 조회 시작');
        const savedSelectedSubTest = await gprojectActions.selectSelectedSubTestDirect(gprojectId);
        console.log('DB에서 가져온 대체성적서 정보:', savedSelectedSubTest);

        // 스텝 2-1: DB에서 가져온 대체성적서 정보를 resData에 병합
        // savedSelectedSubTest.selectedSubTest이 실제 객체
        if (savedSelectedSubTest && savedSelectedSubTest.selectedSubTest) {
          console.log('대체성적서 정보 병합 시작');
          console.log('=== resData 구조 분석 ===');
          console.log('resData 타입:', typeof resData);
          console.log('resData 길이:', Array.isArray(resData) ? resData.length : '배열 아님');
          console.log('resData 첫 번째 항목:', resData[0]);
          console.log('resData 전체 구조:', JSON.stringify(resData, null, 2));
          
          const currentByFolder = await loadCurrentSubstituteFiles(savedSelectedSubTest.selectedSubTest);
          const updatedResData = applySavedSubstituteDocuments(resData, savedSelectedSubTest.selectedSubTest, currentByFolder);
          console.log('대체성적서가 병합된 resData:', updatedResData);
          // resData를 업데이트된 데이터로 교체
          resData.splice(0, resData.length, ...updatedResData);
        }

        // 스텝 3: DB에서 저장된 수정 시험성과대비표 정보 가져오기
        console.log('DB에서 수정 시험성과대비표 정보 조회 시작');
        const savedSelectedModifiedGTestComparisons = await gprojectActions.selectGProjectGTestComparisonsDirect(gprojectId);
        console.log('DB에서 가져온 수정 시험성과대비표 정보:', savedSelectedModifiedGTestComparisons);

        // 스텝 3-1: DB에서 가져온 수정 시험성과대비표 정보를 resData에 병합
        if (savedSelectedModifiedGTestComparisons && savedSelectedModifiedGTestComparisons.length > 0) {
          console.log('수정 시험성과대비표 정보 병합 시작');
          console.log('=== resData 구조 분석 ===');
          console.log('resData 타입:', typeof resData);
          console.log('resData 길이:', Array.isArray(resData) ? resData.length : '배열 아님');
          console.log('resData 첫 번째 항목:', resData[0]);
          console.log('resData 전체 구조:', JSON.stringify(resData, null, 2));

          const updatedResData = applySavedModifiedGTestComparisons(resData, savedSelectedModifiedGTestComparisons);
          console.log('수정 시험성과대비표가 병합된 resData:', updatedResData);
          // resData를 업데이트된 데이터로 교체
          resData.splice(0, resData.length, ...updatedResData);
        }

        // TODO : 아래 중복처리 두 함수의 기능은 추후 검토 필요함. 서버로 이전할 수도 있음
        // 가스주입 단열유리, 복층유리 성능확인서 중복 제거 처리
        let processedResData = removeDuplicateInsulatedGlazingPerformance(resData);

        // 가공부자재, 시공부자재에서
        // 1. 인증규격이 같은 경우 중복 인증서 제거 처리 => 중복제거하면 제거된 인증규격이 없으므로 이 인증규격을 사용하려면 다른 방법이 필요
        // 2. 대부분 아직 표준인증이 없으므로 인증서가 없는 경우가 있음. 이럴 경우 인증서 하위에 children이 없는 경우는 인증서 노드 자체를 지움
        processedResData = processSubMaterialCertifications(processedResData);
        // processedResData = processSubMaterials(processedResData);

        processedResData = pasteStandardNo(processedResData);
        console.log(processedResData)

        if (gsupplyConfirm) {
          const resGSupplyConfirms = await selectAllGSupplyConfirmsDirect({ searchType: 'request', gprojectId, status: [/*'발행', */'완료'] }); // TODO : status를 '완료'로 해야 함. 지금은 테스트중...
          console.log(resGSupplyConfirms)
          setGSupplyConfirms(resGSupplyConfirms)

          const gsupplyConfirmData = await getGSupplyConfirmData(resGSupplyConfirms);

          const gsupplyConfirmForTree = [{
            id: `${gprojectId}/summary`,
            label: '요약표',
            type: 'GSUPPLY_CONFIRM_SUMMARY',
            data: {
              tableData: gsupplyConfirmData,
              gclientId: id,
              gclient: { ...sessionUser, opened: true },
            }
          }];

          console.log(gsupplyConfirmData)

          gsupplyConfirmForTree.push( // 업체별 노드 추가
            ...Array.from(new Set(gsupplyConfirmData.map(item => item.company)))
              .filter(company => company) // 빈 값 필터링
              .map(company => {
                const companyData = gsupplyConfirmData.find(item => item.company === company);
                const gclient = newGClients.find(gc => gc.id === companyData.gclientId); // 새로 조회한 거래선 정보를 이용함
                return {
                  id: `${gprojectId}/company/${companyData.gclientId}`,
                  label: company,
                  type: 'GSUPPLY_CONFIRM_DOC',
                  data: {
                    gclientId: companyData.gclientId,
                    gclient,
                  }
                };
              }));
              
          console.log(gsupplyConfirmForTree)

          // 각 노드에 대해 매칭되는 공급확인서 데이터 추가
          gsupplyConfirmForTree.forEach(node => {
            if (node.type === 'GSUPPLY_CONFIRM_DOC') {
              const matchingSupplyConfirm = resGSupplyConfirms.find(supply => 
                supply.gprojectId === gprojectId && 
                supply.supplyGClientId === node.data.gclientId &&
                supply.status === '완료' // status가 '완료'인 경우만 필터링
              );
              
              if (matchingSupplyConfirm) {
                node.data = {
                  ...node.data,
                  documentPath: matchingSupplyConfirm.documentPath,
                };
              }
            }
          });

          console.log(gsupplyConfirmForTree)

          data.find(i => i.id === 'GSUPPLY_CONFIRM').children = gsupplyConfirmForTree;
          // resData.find(i => i.id === 'GSUPPLY_CONFIRM').children = gsupplyConfirmForTree;
          processedResData.find(i => i.id === 'GSUPPLY_CONFIRM').children = gsupplyConfirmForTree;
        }

        setG04docuDataWithoutDocus(data);
        // setG04docuDataWithDocus(resData);
        setG04docuDataWithDocus(processedResData);

        // 필요 자재승인서류 내 거래선과 securityOpenedGClientsAboutMe 비교하여 해당 비공개 거래선에 대하여 안내한다.
        // const closedAboutMe = relatedGClients.filter(a => securityOpenedGClientsAboutMe.some(b => a.id !== b.id));
        setGClientsInMaterialApproval(relatedGClients);

        const closedAboutMe = compare(relatedGClients, securityOpenedGClientsAboutMe);
        if (closedAboutMe.length > 0) {
          // console.log(closedAboutMe)
          const closedAboutMeWithStatus = await selectGClientsBySecurityRequestStatusByQueryDirect({ senderId: sessionUser.id, receiverIds: closedAboutMe.map(gc => gc.id) });
          setClosedGClientList(closedAboutMeWithStatus);
          setOpenRequest(true);
          setTimeout(() => {
            setLoaded(true);
          }, 300);
        }
      }
      } finally {
        setBuildingToc(false);
      }
    }
  }

  // 시가공부자재의 경우 인증서가 없는 경우가 있음.
  // 이럴 경우 인증서 하위에 children이 없는 경우는 인증서 노드 자체를 지움
  const processSubMaterials = (nodes) => {
    console.log(nodes)
    return nodes?.map(client => {
      // client의 children 배열을 순회하면서 인증서 카테고리 처리
      const updatedChildren = client.children?.filter(category => {
        // 인증서 카테고리이고 children이 없거나 비어있는 경우 제거
        if (category.type === 'CERTIFICATIONS') {
          return category.data && category.data.g04docuGCertificationIds && category.data.g04docuGCertificationIds.length > 0;
        }
        return true; // 다른 카테고리는 유지
      });

      return {
        ...client,
        children: updatedChildren
      };
    });
  };
  
  /**
 * 가공부자재, 시공부자재의 인증규격이 같은 경우 중복된 인증서를 제거하고 제목을 통합하는 함수
 * 
 * 처리 로직:
 * 1. 가공부자재와 시공부자재 부분만 처리 (division.id가 'SUB_MATERIAL_PROCESS' 또는 'SUB_MATERIAL_BUILD')
 * 2. 각 거래선(client) 노드 내의 인증서(CERTIFICATIONS) 카테고리에서:
 *   - 실제 인증서 노드의 data.g04docuGCertificationId를 이용해 표준번호(gstandardNo) 찾음
 *   - 표준번호는 인증서 카테고리의 data.g04docuGCertifications에서 매칭
 *   - 같은 표준번호를 가진 인증서들을 하나로 통합
 *   - 통합 시 첫 번째 인증서만 남기고 나머지는 제거
 *   - 통합된 인증서의 제목은 원래 인증서들의 제목을 '/'로 구분하여 표시
 * 
 * @param {Array} resData - 전체 트리 데이터 배열
 * @returns {Array} - 중복 제거 및 제목 통합이 완료된 트리 데이터 배열
 */
  const processSubMaterialCertifications = (resData) => {
    return resData.map(division => {
      // 가공부자재와 시공부자재 부분만 처리
      if (division.id === 'SUB_MATERIAL_PROCESS' || division.id === 'SUB_MATERIAL_BUILD') {
        const updatedChildren = division.children?.map(client => {
          // client.children에서 요소가 type === CERTIFICATIONS 인 경우에 대해
          // category.children 돌면서 요소의 data.documentPath가 있는 경우는 패스
          // 없는데 data.g04docuGCertificationId를 보고 client.children 요소의 g04docuGCertifications에 찾아서 gstandardId를 찾고
          // 이걸로 store의 gstandards를 찾아서 gstandardTypeCode가 SELF이면 빼고...
          const filteredChildren = client.children?.map(category => {
            if (category.type !== 'CERTIFICATIONS') {
              return category;
            }

            const certChildren = category.children || [];
            const filteredCertChildren = certChildren.filter(certNode => {
              if (certNode.data?.documentPath) {
                return true;
              }

              const certId = certNode.data?.g04docuGCertificationId;
              const certInfo = category.data?.g04docuGCertifications?.find(
                cert => cert.g04docuGCertificationId === certId
              );
              const gstandardId = certInfo?.gstandardId;
              if (gstandardId) {
                const standard = gstandards.find(std => std.id === gstandardId);
                console.log(standard)
                return standard?.gstandardTypeCode !== 'SELF';
              }

              return true;
            });

            console.log(filteredCertChildren)
            // 필터링된 하위 목록이 비어있으면 null을 반환하여 이후에 제거될 수 있도록 함
            if (filteredCertChildren.length === 0) {
              return null;
            }

            return {
              ...category,
              children: filteredCertChildren
            };
          }).filter(Boolean); // null 값을 제거
          console.log(filteredChildren)

          const updatedClientChildren = filteredChildren.map(category => { // 회사별 문서종류 (client.children(category) = 일반문서, 인증서, 성적서, 기타)
            if (category.type === 'CERTIFICATIONS') { // 인증서 카테고리 처리
              const certChildren = category.children || [];

              // 중복 제거를 위한 Map (key: gstandardNo, value: 인증서 노드)
              const uniqueCerts = new Map();
              // 중복된 인증서들의 제목을 저장하기 위한 Map (key: gstandardNo, value: 제목 배열)
              const certTitles = new Map();
              // 중복된 인증서들의 ID를 저장하기 위한 Map (key: gstandardNo, value: ID 배열)
              const certIds = new Map();

              certChildren.forEach(certNode => {
                const certId = certNode.data?.g04docuGCertificationId;
                // g04docuGCertifications 배열에서 해당 인증서의 표준번호 찾기
                const certInfo = category.data?.g04docuGCertifications?.find(
                  cert => cert.g04docuGCertificationId === certId
                );
                const gstandardNo = certInfo?.gstandardNo;

                if (gstandardNo) {
                  if (!uniqueCerts.has(gstandardNo)) {
                    // 처음 나온 표준번호인 경우
                    uniqueCerts.set(gstandardNo, {
                      ...certNode,
                      originalLabel: certNode.label, // 원래 제목 저장
                      data: {
                        ...certNode.data,
                        g04docuGCertificationIds: [certId] // ID 배열 초기화
                      }
                    });
                    certTitles.set(gstandardNo, [certNode.label]);
                    certIds.set(gstandardNo, [certId]);
                  } else {
                    // 이미 있는 표준번호인 경우 제목과 ID 저장
                    certTitles.get(gstandardNo).push(certNode.label);
                    certIds.get(gstandardNo).push(certId);
                    
                    // 기존 노드의 제목과 ID 배열 업데이트
                    const existingNode = uniqueCerts.get(gstandardNo);
                    existingNode.label = [...new Set(certTitles.get(gstandardNo))].join(' / ');
                    existingNode.data.g04docuGCertificationIds = certIds.get(gstandardNo);
                  }
                } else {
                  // 표준번호가 없는 경우는 그대로 유지
                  uniqueCerts.set(certNode.id, {
                    ...certNode,
                    data: {
                      ...certNode.data,
                      g04docuGCertificationIds: [certId]
                    }
                  });
                }
              });

              return {
                ...category,
                children: Array.from(uniqueCerts.values())
              };
            }
            return category;
          });

          // client의 label 업데이트
          const certsCategory = updatedClientChildren?.find(cat => cat.type === 'CERTIFICATIONS');
          const validItems = certsCategory?.children || [];
          const itemNames = validItems.map(item => item.originalLabel || item.label).join(",");
          
          return {
            ...client,
            children: updatedClientChildren,
          };
        });

        return {
          ...division,
          children: updatedChildren
        };
      }
      return division;
    });
  };

  /**
   * 가스주입 단열유리의 경우 성적서가 없어서 성능확인서가 발급된 경우, 복층유리와 사양이 같고 발행된 성능확인서가 완전히 동일함 (복층유리에 AR이 있으면 가스주입 단열유리가 따로 존재하는 것이 아니라 노드가 추가되는 것임)
   * 자재승인서(납품확인서) 목차 구성할 때 가스주입 단열유리와 복층유리에 각각 등록된 성적서가 없으면 개별로 성능확인서가 발급될 것이고 이는 완전히 동일한 문서임
   * 그렇기 때문에 중복된 성능확인서에 대한 처리가 필요함
   * 처리방법
   *  - 복층유리에서 AR이 있으면 가스주입 단열유리 노드가 만들어진 것이기 때문에 둘은 완전히 동일한 사양임
   *  - 사양이 같은(커플로 되어 있는) 복층유리와 가스주입 단열유리 모두 성적서가 없고 성능확인서만 있으면 목차에서 제거함
   *  - 가스주입 단열유리 노드 아래에 존재하는 실제 유리를 노드에서 제거
   *  - 가스주입 단열유리 노드 아래에 모든 유리가 하나도 없다면 없다면 상위의 가스주입 단열유리 노드 자체를 제거
   */
  const removeDuplicateInsulatedGlazingPerformance = (resData) => {
    return resData.map(division => {
      if (division.id === 'PROCESS') { // 가공 부분만 처리
        const updatedChildren = division.children?.map(client => { // 각 거래선의 자식 노드들 처리
          const updatedClientChildren = client.children?.map(category => {
            if (category.type === 'TESTS') { // 성적서 카테고리 처리
              const testsChildren = category.children || [];
              
              // 복층유리 노드 찾기
              const insulatedGlassUnitNode = testsChildren.find(item => item.data?.code === 'INSULATED_GLASS_UNIT');
              
              // 가스주입 단열유리 노드 찾기
              const insulatedGlazingNode = testsChildren.find(item => item.data?.code === 'INSULATED_GLAZING');
    
              if (insulatedGlassUnitNode && insulatedGlazingNode) {
                // 가스주입 단열유리 노드의 children을 필터링
                const filteredGasChildren = insulatedGlazingNode.children?.filter(gasChild => {
                  // 복층유리에서 동일한 사양 찾기
                  const matchingInsulatedChild = insulatedGlassUnitNode.children?.find(insChild => 
                    // 사양이 동일한지 확인
                    insChild.data?.code === gasChild.data?.code &&
                    // 둘 다 성적서가 없고
                    !insChild.data?.documentPath && 
                    !gasChild.data?.documentPath &&
                    // 성능확인서가 있는지 확인
                    // 성능확인서이 각각 발행되었으므로 내용은 동일하지만 파일 경로는 다르므로
                    // insChild.data?.performanceData?.performanceDocumentPath === gasChild.data?.performanceData?.performanceDocumentPath 까지는 비교안함
                    insChild.data?.performanceData?.performanceDocumentPath &&
                    gasChild.data?.performanceData?.performanceDocumentPath
                  );
                  
                  // 매칭되는 항목이 없으면 유지
                  return !matchingInsulatedChild;
                });
    
                // 필터링된 children으로 가스주입 단열유리 노드 업데이트
                insulatedGlazingNode.children = filteredGasChildren;
    
                // 필터링 후 children이 없는 가스주입 단열유리 노드는 제거
                const updatedTestsChildren = testsChildren.filter(node => 
                  node.data?.code !== 'INSULATED_GLAZING' || 
                  (node.data?.code === 'INSULATED_GLAZING' && node.children?.length > 0)
                );
    
                return {
                  ...category,
                  children: updatedTestsChildren
                };
              }
            }
            return category;
          });
    
          // client의 label 업데이트
          const testsCategory = updatedClientChildren?.find(cat => cat.type === 'TESTS');
          const validItems = testsCategory?.children || [];
          const itemNames = validItems.map(item => item.label).join(",");
          
          return {
            ...client,
            children: updatedClientChildren,
            label: `${client.data.gclient.name}:${itemNames}` // 필터링된 항목들로 label 재구성
          };
        });
    
        return {
          ...division,
          children: updatedChildren
        };
      }
      return division;
    });
  }

  const compare = (array1, array2) => array1.filter(i => !array2.some(o => i.id === o.id))

  // DB에서 가져온 대체성적서 정보를 resData에 병합하는 함수
  const loadCurrentSubstituteFiles = async (selectedSubTest) => {
    const byClient = new Map();
    Object.values(selectedSubTest || {}).forEach((item) => {
      if (!item?.substituteFolderId || item.substituteDocumentType === 'performance') return;
      const key = item.gclientId || '';
      if (!byClient.has(key)) byClient.set(key, []);
      byClient.get(key).push(item.substituteFolderId);
    });
    const found = {};
    for (const [gclientId, folderIds] of byClient) {
      const files = await subMatFolderActions.selectSubstituteCandidatesDirect({
        gclientId: gclientId || undefined,
      });
      const byFolder = new Map((files || []).map((file) => [file.folderId, file]));
      folderIds.forEach((folderId) => {
        found[folderId] = byFolder.get(folderId) || null;
      });
    }
    return found;
  };

  const applySavedSubstituteDocuments = (resData, selectedSubTest, currentByFolder = {}) => {
    console.log('applySavedSubstituteDocuments 시작:', { resData, selectedSubTest });
    
    // selectedSubTest가 객체인 경우 처리
    if (!selectedSubTest || typeof selectedSubTest !== 'object') {
      console.log('유효하지 않은 selectedSubTest:', selectedSubTest);
      return resData;
    }
    
    // selectedSubTest 객체의 모든 속성을 순회하면서 처리
    let updatedResData = [...resData];
    
    Object.keys(selectedSubTest).forEach(key => {
      const subTestData = selectedSubTest[key];
      if (!subTestData || typeof subTestData !== 'object') {
        console.log('유효하지 않은 subTest 데이터:', subTestData);
        return;
      }
      
      const { id: subTestId, g04docuGTestId, substituteDocumentPath, substituteDocumentName, substituteDocumentType, substituteDocumentValid, substituteDocumentValidYN, substituteFolderId } = subTestData;
      if (!subTestId) {
        console.log('유효하지 않은 subTest ID:', subTestData);
        return;
      }

      console.log(`=== ${key} subTest 처리 ===`);
      console.log('subTest.id:', subTestId);
      console.log('subTest.substituteDocumentPath:', substituteDocumentPath);
      
      // TestReportManagerDialog의 updateDocumentInTree 로직을 참고하여 구현
      updatedResData = updatedResData.map(item => {
        // 구분 노드 처리
        if (['SUPPLIER', 'RAW_MATERIAL', 'PROCESS', 'SUB_MATERIAL_PROCESS', 'SUB_MATERIAL_BUILD'].includes(item.id)) {
          const updatedChildren = item.children?.map(companyNode => {
            // 업체 노드 처리
            const updatedCompanyChildren = companyNode.children?.map(child => {
              if (child.type === 'TESTS') {
                // TESTS 노드 처리
                const updatedTestChildren = child.children?.map(testCategory => {
                  // 테스트 카테고리 노드 처리. 부자재 규격은 한 단계 더 있다.
                  const visitDoc = (doc) => {
                    console.log('doc.id:', doc.id);
                    console.log('subTestId:', subTestId);
                    // 문서 노드에서 targetId와 일치하는 문서 찾기
                    if (doc.id === subTestId) {
                      console.log('=== 대상 문서 발견 ===');
                      console.log('doc.id:', doc.id);
                      console.log('기존 doc.data:', JSON.stringify(doc.data, null, 2));
                      console.log('subTestData:', JSON.stringify(subTestData, null, 2));
                      
                      // 선택된 문서 정보로 업데이트
                      const updatedData = {
                        ...doc.data,
                      };
                      
                      // 성능확인서인지 확인
                      const isPerformanceDocument = substituteDocumentType === 'performance';

                      if (substituteFolderId && !isPerformanceDocument) {
                        const exact = doc.data?.documentPath && doc.data?.substitute !== 'Y';
                        if (exact) {
                          return doc;
                        }
                        const current = currentByFolder[substituteFolderId];
                        const updatedData = {
                          ...doc.data,
                          substituteFolderId,
                        };
                        if (!current?.documentPath) {
                          updatedData.documentPath = null;
                          updatedData.substitute = 'N';
                          updatedData.substituteDocumentName = null;
                          updatedData.gtestComparisonDocumentPath = null;
                        } else {
                          const expired = current.validYN !== true
                            && current.endDate
                            && new Date(current.endDate).getTime() < Date.now();
                          updatedData.documentPath = current.documentPath;
                          updatedData.substitute = 'Y';
                          updatedData.substituteDocumentName = current.fileName || current.folderName;
                          updatedData.substituteDocumentType = '대체성적서';
                          updatedData.valid = !expired;
                          updatedData.validYN = current.validYN;
                          updatedData.gtestComparisonDocumentPath = current.comparisonDocumentPath || null;
                          updatedData.g04docuGTestId = null;
                        }
                        return {
                          ...doc,
                          data: updatedData,
                        };
                      }
                      
                      if (isPerformanceDocument) {
                        // 성능확인서는 performanceData에 저장
                        updatedData.performanceData = {
                          ...doc.data?.performanceData,
                          performanceDocumentPath: substituteDocumentPath
                        };
                        updatedData.substitute = 'N';
                        updatedData.substituteFolderId = null;
                        // 성능확인서 선택 시 기존 대체성적서 정보만 초기화
                        if (doc.data?.substitute === 'Y') {
                          updatedData.documentPath = null;
                        }
                        console.log('성능확인서 업데이트:', updatedData.performanceData);
                      } else {
                        // 일반 성적서는 대체성적서로 표시
                        updatedData.g04docuGTestId = g04docuGTestId;
                        updatedData.documentPath = substituteDocumentPath;
                        updatedData.substitute = 'Y';
                        updatedData.substituteDocumentName = substituteDocumentName;
                        
                        // 유효성 정보 업데이트 (대체성적서일 때만)
                        if (substituteDocumentValid !== undefined) {
                          updatedData.valid = substituteDocumentValid;
                        }
                        // if (substituteDocumentValidYN !== undefined) {
                        //   updatedData.validYN = substituteDocumentValidYN;
                        // }
                        
                        // 시험성과대비표 정보 추가
                        if (subTestData?.gtestComparisonDocumentPath) {
                          updatedData.gtestComparisonDocumentPath = subTestData.gtestComparisonDocumentPath;
                        }
                        
                        console.log('일반 성적서 업데이트:', updatedData);
                      }
                      
                      console.log('업데이트된 doc.data:', updatedData);
                      
                      return {
                        ...doc,
                        data: updatedData
                      };
                    }
                    if (doc.children?.length) {
                      return { ...doc, children: doc.children.map(visitDoc) };
                    }
                    return doc;
                  };

                  return {
                    ...testCategory,
                    children: testCategory.children?.map(visitDoc)
                  };
                });

                return {
                  ...child,
                  children: updatedTestChildren
                };
              }
              return child;
            });

            return {
              ...companyNode,
              children: updatedCompanyChildren
            };
          });

          return {
            ...item,
            children: updatedChildren
          };
        }
        return item;
      });
    });
    
    return updatedResData;
  };

  const applySavedModifiedGTestComparisons = (resData, savedSelectedModifiedGTestComparisons) => {
    console.log('applySavedModifiedGTestComparisons 시작:', { resData, savedSelectedModifiedGTestComparisons });
    
    // savedSelectedModifiedGTestComparisons가 배열인 경우 처리
    if (!savedSelectedModifiedGTestComparisons || !Array.isArray(savedSelectedModifiedGTestComparisons)) {
      console.log('유효하지 않은 savedSelectedModifiedGTestComparisons:', savedSelectedModifiedGTestComparisons);
      return resData;
    }
    
    // 수정 시험성과대비표 정보가 없는 경우 처리하지 않음
    if (savedSelectedModifiedGTestComparisons.length === 0) {
      console.log('수정 시험성과대비표 정보가 없음');
      return resData;
    }
    
    let updatedResData = [...resData];
    
    // 각 수정 시험성과대비표 정보를 순회하면서 처리
    savedSelectedModifiedGTestComparisons.forEach(modifiedComparison => {
      if (!modifiedComparison || typeof modifiedComparison !== 'object') {
        console.log('유효하지 않은 modifiedComparison 데이터:', modifiedComparison);
        return;
      }
      
      const { g04docuGTestId, documentPath } = modifiedComparison;
      if (!g04docuGTestId) {
        console.log('유효하지 않은 g04docuGTestId:', modifiedComparison);
        return;
      }

      console.log(`=== 수정 시험성과대비표 처리 ===`);
      console.log('g04docuGTestId:', g04docuGTestId);
      console.log('gtestComparisonDocumentPath:', documentPath);
      
      // resData를 순회하면서 해당 g04docuGTestId를 가진 문서 찾기
      updatedResData = updatedResData.map(item => {
        // 구분 노드 처리
        if (['SUPPLIER', 'RAW_MATERIAL', 'PROCESS', 'SUB_MATERIAL_PROCESS', 'SUB_MATERIAL_BUILD'].includes(item.id)) {
          const updatedChildren = item.children?.map(companyNode => {
            // 업체 노드 처리
            const updatedCompanyChildren = companyNode.children?.map(child => {
              if (child.type === 'TESTS') {
                // TESTS 노드 처리
                const updatedTestChildren = child.children?.map(testCategory => {
                  // 테스트 카테고리 노드 처리
                  const updatedTestDocs = testCategory.children?.map(doc => {
                    console.log('doc.data?.g04docuGTestId:', doc.data?.g04docuGTestId);
                    console.log('g04docuGTestId:', g04docuGTestId);
                    
                    // 문서 노드에서 g04docuGTestId와 일치하는 문서 찾기
                    if (doc.data?.g04docuGTestId === g04docuGTestId) {
                      console.log('=== 대상 문서 발견 (수정 시험성과대비표) ===');
                      console.log('doc.id:', doc.id);
                      console.log('기존 doc.data:', JSON.stringify(doc.data, null, 2));
                      console.log('modifiedComparison:', JSON.stringify(modifiedComparison, null, 2));
                      
                      // 선택된 문서 정보로 업데이트
                      const updatedData = {
                        ...doc.data,
                      };
                      
                      // gtestComparisonDocumentPath가 없는 경우에만 isModifiedComparisonOnly 태그 추가
                      if (!updatedData.gtestComparisonDocumentPath) {
                        updatedData.isModifiedComparisonOnly = true;
                        console.log('isModifiedComparisonOnly 태그 추가됨');
                      }
                      
                      // 수정 시험성과대비표 정보 업데이트
                      if (documentPath) {
                        updatedData.gtestComparisonDocumentPath = documentPath;
                        console.log('수정 시험성과대비표 경로 업데이트:', documentPath);
                      }
                      
                      console.log('업데이트된 doc.data:', updatedData);
                      
                      return {
                        ...doc,
                        data: updatedData
                      };
                    }
                    return doc;
                  });

                  return {
                    ...testCategory,
                    children: updatedTestDocs
                  };
                });

                return {
                  ...child,
                  children: updatedTestChildren
                };
              }
              return child;
            });

            return {
              ...companyNode,
              children: updatedCompanyChildren
            };
          });

          return {
            ...item,
            children: updatedChildren
          };
        }
        return item;
      });
    });
    
    return updatedResData;
  };

  const reGenerate = async () => {
    // const resData = await generateDirect(g04docuDataWithoutDocus, selectedRow.id);
    // setG04docuDataWithDocus(resData);
    regenerate(selectedRow, gcertifications)
  }

  const initDialog = () => {
    // setSelected([]); // 초기화
    setG04docuDataWithoutDocus([]); // 문서 없는 데이터 초기화
    setG04docuDataWithDocus([]); // 문서 있는 데이터 초기화
    setDocumentPath(""); // 문서 경로 초기화
  }

  // 컴포넌트가 마운트될 때 저장된 체크상태 불러오기
  useEffect(() => {
    if (open && selectedRow) {
      const storageKey = getStorageKey(gsupplyConfirm, selectedRow.id);
      const savedState = getLocalStorageWithExpiry(storageKey);
      setSelected(savedState || []); // 저장된 상태가 없거나 만료된 경우 빈 배열로 초기화
    }
  }, [open, selectedRow, gsupplyConfirm]);

  // TODO : 미리보기가 공통으로 많이 사용되므로 공통함수 검토
  // 미리보기할 때 원본을 그대로 보여줄 경우 거래선의 문서들이 무작위로 배포될 우려가 있으므로 미리보기하면 미리보기용 문서를 만들고(원본문서+미리보기 표시) 그것을 보여줌
  // const handleClickViewEachDoc = (documentPath, gclientId) => {
  //   let path = "";
  //   if (sessionUser.type === 'ADMIN' || sessionUser.id === gclientId) {
  //     const randNumber = Math.floor(Math.random()*99); // 캐싱으로 인해 이전 문서가 계속 보이는 문제 해결
  //     const encodedPath = encodeURIComponent(documentPath.replace(uploadFilePath, ''));
  //     path = `${fileServerUrl}${encodedPath}?q=cat&${randNumber}`;
  //   } else {
  //     path = `${filePreviewServerUrl}${encodeURIComponent(documentPath)}`;
  //   }
  //   window.open(`${path}`, "미리보기", 'target="_self"');
  // }
  const handleClickViewEachDoc = (documentPath, gclientId) => {
    if (!!!documentPath) {
      return;
    }
    
    let path = "";
    // API 서버 OS가 Windows인 경우 경로에 \\가 포함되어 있어서 이를 /로 변환. replace(/\\/g, '/')
    // development, production 환경에서는 불필요하나 local에서 개발할 때 필요
    if (sessionUser.type === 'ADMIN' || sessionUser.id === gclientId) {
      const randNumber = Math.floor(Math.random()*99); // 캐싱으로 인해 이전 문서가 계속 보이는 문제 해결
      
      // uploadFilePath를 제거한 경로를 '/'로 분할
      const pathParts = documentPath.replace(/\\/g, '/').replace(uploadFilePath, '').split('/');
      
      // 각 디렉터리를 개별적으로 인코딩하고 다시 '/'로 결합
      const encodedPath = pathParts
        .map(part => encodeURIComponent(part))
        .join('/');
        
      path = `${fileServerUrl}${encodedPath}?q=cat&${randNumber}`;
    } else {
      // 미리보기 서버용 경로도 같은 방식으로 처리
      const pathParts = documentPath.replace(/\\/g, '/').split('/');
      const encodedPath = pathParts
        .map(part => encodeURIComponent(part))
        .join('/');
      path = `${filePreviewServerUrl}${encodedPath}`;
    }
    // window.open(`${path}`, "미리보기", 'target="_self"');
    setCurrentUrl(path);
    // Drawer가 닫혀있을 때만 열기
    if (!documentViewerDrawerOpen) {
      setDocumentViewerDrawerOpen(true);
    }
  }

  const handleClickViewSummary = () => {
    setOpenSummary(true);
  }

  const closeDrawerAndRegenerate = () => {
    const e = new Event(null);
      
    toggleDrawer("G04DOCU_GTEST_SUBSTITUTE", false)(e);  
    reGenerate();
  }

  const handleClickAddSubstituteTestDoc = (e, data) => {
    console.log(selectedRow)
    console.log(data)
    // setOpenSubstitute(true);
    
    const { id, site } = selectedRow;
    const { name, code, division, gclientId, g04docuGCertificationName, gcomponentItemName } = data;

    setDataForGTestSubstitute({
      source: "GProjectG04GeneratorDialog",
      params: {
        name: name,
        code: code,
        gclientId: gclientId,
        division: division,
        itemOrCertificationName: division === 'RAW_MATERIAL' ? gcomponentItemName : g04docuGCertificationName,
        gprojectId: id,
        site: site,
        closeDrawerAndRegenerate,
      }
    })

    // setShow(false); // 현재 다이얼로그를 숨기고 Drawer 열어야 함. 그래서 toggleDrawer 내부를 보면 닫힐 때 다시 다이얼로그를 보이게 하는 부분이 있음

    // toggleDrawer("G04DOCU_GTEST_SUBSTITUTE", true)(e);  
  }

  useEffect(
    () => {
      console.log(dataForGTestSubstitute)
      if (dataForGTestSubstitute) {
        setShow(false); // 현재 다이얼로그를 숨기고 Drawer 열어야 함. 그래서 toggleDrawer 내부를 보면 닫힐 때 다시 다이얼로그를 보이게 하는 부분이 있음
        const e = new Event(null);
      
        toggleDrawer("G04DOCU_GTEST_SUBSTITUTE", true)(e);  
      }
    }, [dataForGTestSubstitute]
  )

  useEffect(
    () => {
      console.log(dataForMaterialApproval)
      if (dataForMaterialApproval) {
        setShow(false); // 현재 다이얼로그를 숨기고 Drawer 열어야 함. 그래서 toggleDrawer 내부를 보면 닫힐 때 다시 다이얼로그를 보이게 하는 부분이 있음
        const e = new Event(null);
      
        toggleDrawer("G04DOCU_MATERIAL_APPROVAL", true)(e);  
      }
    }, [dataForMaterialApproval]
  )

  // const dataForMaterialApproval = () => {
  //   setOpenSubstitute(false);
  // }

  const handleClickViewMaterialApproval = (documentPath) => {
    const path = documentPath.replace(uploadFilePath, fileServerUrl);
    
    // 캐싱으로 인해 이전 문서가 계속 보이는 문제 해결
    const randNumber = Math.floor(Math.random()*99);

    window.open(`${path}?q=cat&${randNumber}`, "미리보기", 'target="_self"');
  }

  useEffect(
    () => {
      const pgViewerWrapper = document.getElementsByClassName("pg-viewer-wrapper");
      const pgViewer = document.getElementById("pg-viewer");
      
      console.log(pgViewerWrapper)
      console.log(pgViewerWrapper[0])
      console.log(pgViewer)
      if (pgViewerWrapper && pgViewerWrapper.length > 0 && pgViewer) {
      // if (pgViewerWrapper && pgViewer) {
        pgViewer.style.backgroundColor = "grey";
        pgViewerWrapper[0].style.overflowY = "hidden";
      }
    }, [showFileViewer]
  )

  const onError = (e) => {
    console.log(e)
  }

  // TODO : G04docuMaterialApprovalDialog.js에서 사용중이므로 통합할 것
  const getFileType = (documentPath) => {
    let ext = "pdf";
    const pos = documentPath.lastIndexOf(".");
    if (pos > -1) {
      ext = documentPath.substring(pos+1);
    }

    return ext;
  }

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    
    setDrawerState({ ...drawerState, [anchor]: open });

    if (!open) {
      // setOpen(true);
      setShow(true);
    }
  };

  const handleClickRequest = async (e, params) => {
    // console.log(params)
    const { id: receiverId } = params.row; // receiverId;

    await createSecurityRequest({ id: uuidv4(), senderId: sessionUser.id, receiverId, service: '04docu', status: '요청' });
    
    refreshClosedGClients();
  }

  const handleClickRequestAgain = async (e, params) => {
    // console.log(params)
    const { securityRequestId: id, id: receiverId } = params.row; // securityRequestId;

    await modifySecurityRequest({ id, senderId: sessionUser.id, receiverId, service: '04docu', status: '요청' });
    
    refreshClosedGClients();
  }

  const refreshClosedGClients = async () => {
    const service = '04docu';
    const securityOpenedGClientsAboutMe = await selectOpenedAboutMeGClientListDirect(service, sessionUser.id);
    const closedAboutMe = compare(gclientsInMaterialApproval, securityOpenedGClientsAboutMe)
    if (closedAboutMe.length > 0) {
      const closedAboutMeWithStatus = await selectGClientsBySecurityRequestStatusByQueryDirect({ senderId: sessionUser.id, receiverIds: closedAboutMe.map(gc => gc.id) });
      setClosedGClientList(closedAboutMeWithStatus);
    }

    // const closedAboutMeWithStatus = await selectGClientsBySecurityRequestStatusByQueryDirect({ senderId: sessionUser.id, receiverIds: closedGClientList.map(gc => gc.id) });
    // setClosedGClientList(closedAboutMeWithStatus);
  }

  const closeDrawer = () => {
    const e = new Event(null);
      
    toggleDrawer("G04DOCU_MATERIAL_APPROVAL", false)(e);
  }

  const showMaterialApproval = (data) => {
    const { g04docuMaterialApproval } = data;
    setDataForMaterialApproval({
      source: "GProjectG04GeneratorDialog",
      params: {
        g04docuMaterialApprovalId: g04docuMaterialApproval.id,
        docType: g04docuMaterialApproval.docType,
        closeDrawer,
      }
    })
  }

  const columns = [
    {
      field: 'funcions',
      headerName: '기능/상태',
      width: 80,
      // editable: true,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const { status } = params.row;
        if (status) {
          if (status === '요청') {
            return (
              <Button
                disabled
                sx={{ borderRadius: 30, maxWidth: '60px', maxHeight: '60px', minWidth: '60px', minHeight: '60px', backgroundImage: 'url("/requesting.png")', backgroundSize: "60px 60px" }}
              >             
              </Button>
            )
          } else if (status === '비공개') {
            return (
              <Button
                onClick={(e) => handleClickRequestAgain(e, params)}
                sx={{ borderRadius: 30, maxWidth: '60px', maxHeight: '60px', minWidth: '60px', minHeight: '60px', backgroundImage: 'url("/request-again.png")', backgroundSize: "60px 60px" }}
              >             
              </Button>
            )
          }
        } else {
          return (
            <Button
              onClick={(e) => handleClickRequest(e, params)}
              sx={{ borderRadius: 30, maxWidth: '60px', maxHeight: '60px', minWidth: '60px', minHeight: '60px', backgroundImage: 'url("/request.png")', backgroundSize: "60px 60px" }}
            >             
            </Button>
          )
        }
      },
    },
    {
      field: 'bizRegNumber',
      headerName: '사업자등록번호',
      width: 140,
      headerAlign: 'center',
      align: 'center',
      // editable: true,
    },
    {
      field: 'name',
      headerName: '거래선명',
      width: 200,
      // editable: true,
    },
    {
      field: 'ceo',
      headerName: '대표자',
      width: 120,
      // editable: true,
    },
    {
      field: 'phone',
      headerName: '대표전화번호',
      width: 160,
      headerAlign: 'center',
      align: 'center',
      // editable: true,
    },
    {
      field: 'email',
      headerName: '회사대표메일',
      width: 200,
      // editable: true,
    },
    {
      field: 'address',
      headerName: '주소',
      width: 240,
      flex: 1,
      // editable: true,
    },
  ];

  const renderGroupTable = (group) => {
    
  };

  const getStorageKey = (gsupplyConfirm, rowId) => {
    const prefix = gsupplyConfirm 
      ? STORAGE_KEY_PREFIX.SUPPLY_CONFIRM 
      : STORAGE_KEY_PREFIX.MATERIAL_APPROVAL;
    return `${prefix}${rowId}`;
  };

  // 만료 시간을 포함하여 localStorage에 저장하는 함수
  const setLocalStorageWithExpiry = (key, value, ttl) => {
    const item = {
      value: value,
      expiry: new Date().getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item));
  }

  // localStorage에서 값을 가져오고 만료 여부를 확인하는 함수
  const getLocalStorageWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    const now = new Date().getTime();

    // 만료되었다면 항목을 삭제하고 null 반환
    if (now > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  const handleTreeSelect = (newSelected) => {
    console.log('newSelected', newSelected)
    // console.log('itemsWithDocus', g04docuDataWithDocus)
    setSelected(newSelected);
    
    // 선택 상태가 변경될 때마다 localStorage에 저장
    if (selectedRow) {
      const storageKey = getStorageKey(gsupplyConfirm, selectedRow.id);
      setLocalStorageWithExpiry(storageKey, newSelected, TTL_1WEEK);
    }

    // GSUPPLY_CONFIRM_DOC 타입의 노드들 중에서 선택 해제된 것들의 gclientId를 찾아서 저장
    const gsupplyConfirmNode = g04docuDataWithDocus.find(item => item.id === 'GSUPPLY_CONFIRM');
    console.log('gsupplyConfirmNode', gsupplyConfirmNode);
    if (gsupplyConfirmNode?.children) {
      // 납품확인서 노드나 요약표 노드가 선택되었는지 확인
      const gsupplyConfirmSelected = newSelected.includes('GSUPPLY_CONFIRM');
      const summaryNodeSelected = newSelected.includes(gsupplyConfirmNode.children.find(node => 
        node.type === 'GSUPPLY_CONFIRM_SUMMARY'
      )?.id);
       // 납품확인서나 요약표가 선택된 경우 빈 배열로 설정
      if (gsupplyConfirmSelected || summaryNodeSelected) {
        setGSupplyConfirmSummaryFilteredData([]);
        return;
      }
       const excludedIds = gsupplyConfirmNode.children
        .filter(node => 
          node.type === 'GSUPPLY_CONFIRM_DOC' && 
          newSelected.includes(node.id)
        )
        .map(node => node.data.gclientId);
      console.log('excludedIds', excludedIds);
      setExcludedGClientIds(excludedIds);
      
      // 원본 데이터를 유지하면서 필터링된 데이터만 설정
      const filteredData = gsupplyConfirmSummaryData.filter(item => 
        !excludedIds.includes(item.gclientId)
      );
      
      setGSupplyConfirmSummaryFilteredData(filteredData);
      console.log('gsupplyConfirmSummaryData', gsupplyConfirmSummaryData);
      console.log('filteredData', filteredData);

      // g04docuDataWithDocus 업데이트
      const updatedNode = gsupplyConfirmNode.children.find(node => 
        node.type === 'GSUPPLY_CONFIRM_SUMMARY'
      );
      if (updatedNode) {
        updatedNode.data.tableData = filteredData;
      }
    }
  }

  const closeDocumentViewer = () => {
    setDocumentViewerDrawerOpen(false);
  };

  return (
    <>
      {buildingToc && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: (theme) => theme.zIndex.modal + 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            bgcolor: 'rgba(255,255,255,0.88)',
          }}
        >
          <CircularProgress />
          <Typography>목차를 구성하고 있습니다.</Typography>
        </Box>
      )}
      <Dialog
        fullScreen={true}
        open={open}
        onClose={handleDialogClose}
        aria-labelledby="draggable-dialog-title"
        maxWidth="lg"
        scroll="body"
        sx={{ visibility: show ? 'visible' : 'hidden' }}
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          onClose={handleDialogClose}
          fullScreen={true}
          color="white"
          style={{ backgroundColor: "#1976d2" }}
        >
          <div id="dialog-position">
            { gsupplyConfirm ? "납품확인서 생성" : "자재승인서 생성" }
          </div>
        </DialogTitleClose>
        <DialogContent>
          <GProjectG04ContentView
            gsupplyConfirm={gsupplyConfirm}
            crudMode={crudMode}
            setCrudMode={setCrudMode}
            selected={selected}
            onSelect={handleTreeSelect} // onSelect를 새로운 핸들러로 변경
            disableRoot
            itemsWithDocus={g04docuDataWithDocus}      
            setItemsWithDocus={setG04docuDataWithDocus}
            itemsWithoutDocus={g04docuDataWithoutDocus}
            setItemsWithoutDocus={setG04docuDataWithoutDocus}
            handleClickViewEachDoc={handleClickViewEachDoc}
            handleClickViewSummary={handleClickViewSummary}
            handleClickAddSubstituteTestDoc={handleClickAddSubstituteTestDoc}
            handleClickViewMaterialApproval={handleClickViewMaterialApproval}
            disableMultiParentSelection={false}
            makeMaterialApproval={makeMaterialApproval}
            gclient={sessionUser}
            gproject={selectedRow}
            from={{ source: "GProjectG04GeneratorDialog" }}
            showMaterialApproval={showMaterialApproval}
            setParentShow={setShow}
            reGenerate={reGenerate}
            closedGClientList={closedGClientList}
            setOpenRequest={setOpenRequest}
            refreshClosedGClients={refreshClosedGClients}
            documentViewerDrawerOpen={documentViewerDrawerOpen}
            closeDocumentViewer={closeDocumentViewer}
          />
          {
            g04docuDataWithDocus.map((group) => (<div key={group.id}>
              {renderGroupTable(group)}
            </div>))
          }
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
      <Drawer
        anchor={"bottom"} // TODO : 추후 사용자가 환경설정에서 위치 설정하면 전체 반영하는 방법 강구
        open={drawerState["G04DOCU_MATERIAL_APPROVAL"]}
        PaperProps={{
          sx: { width: "100%" },
        }}
        onClose={toggleDrawer("G04DOCU_MATERIAL_APPROVAL", false)}
      >
        <Grid display="flex" justifyContent={"center"} alignItems="center" sx={{ backgroundColor: "#f3f3f3" }}>
          <Tooltip title={"닫기"}>
            <IconButton aria-label="close drawer" size="small" component="span" onClick={toggleDrawer("G04DOCU_MATERIAL_APPROVAL", false)}>
              <KeyboardArrowDown />
            </IconButton>
          </Tooltip>
        </Grid>
        <G04docuMaterialApprovalManagement
          title={gsupplyConfirm ? `납품확인서 생성 결과` : `자재승인서류 생성 결과`}
          from={dataForMaterialApproval}
        />
      </Drawer>
      <Drawer
        anchor={"bottom"} // TODO : 추후 사용자가 환경설정에서 위치 설정하면 전체 반영하는 방법 강구
        open={drawerState["G04DOCU_GTEST_SUBSTITUTE"]}
        PaperProps={{
          sx: { width: "100%" },
        }}
        onClose={toggleDrawer("G04DOCU_GTEST_SUBSTITUTE", false)}
      >
        <Grid display="flex" justifyContent={"center"} alignItems="center" sx={{ backgroundColor: "#f3f3f3" }}>
          <Tooltip title={"닫기"}>
            <IconButton aria-label="close drawer" size="small" component="span" onClick={toggleDrawer("G04DOCU_GTEST_SUBSTITUTE", false)}>
              <KeyboardArrowDown />
            </IconButton>
          </Tooltip>
        </Grid>
        <G04docuGTestManagement
          title={`대체성적서`}
          from={dataForGTestSubstitute}
        />
      </Drawer>
      <Dialog
        open={openRequest}
        onClose={handleRequestDialogClose}
        aria-labelledby="draggable-dialog-title"
        maxWidth="lg"
        fullWidth
        scroll="body"
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          onClose={handleRequestDialogClose}
        >
          <div id="dialog-position">
            {"서류 열람 안내"}
          </div>
        </DialogTitleClose>
        <DialogContent>
          <div style={{ height: 400, width: '100%' }}>
            <DataGridPro
              localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
              headerHeight={64}
              rowHeight={64}
              sx={{ cursor: 'pointer', fontSize: '0.85em' }}
              initialState={{ pinnedColumns: { right: ['actions'] } }}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
                loadingOverlay: LinearProgress,
              }}
              loading={!loaded}
              rows={closedGClientList}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[10, 20, 50, 100]}
              pagination
              // onRowDoubleClick={(params) => handleSelect({ type: 'edit', params })}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRequestDialogClose}>
            {"닫기"}
          </Button>
        </DialogActions>
      </Dialog>
      <GSupplyConfirmSummaryDialog
        open={openSummary}
        setOpen={setOpenSummary}
        summaryData={gsupplyConfirmSummaryFilteredData}
      />
      <DocumentViewerDrawer 
        open={documentViewerDrawerOpen}
        onClose={() => setDocumentViewerDrawerOpen(false)}
        url={currentUrl}
      />
    </>
  );
};

export default GProjectG04GeneratorDialog;
